import React from "react";
import { AiFillFilePdf, AiOutlineCloudDownload } from "react-icons/ai";
import { FaDice, FaSlidersH } from "react-icons/fa";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./../ManualPage/ManualPage.css";

import manualPanel from "./../../images/mono_manual_panel.png";
import manualPanelBack from "./../../images/mono_manual_panel_back.png";
import soundArchitecture from "./../../images/mono_sound_architecture.png";
import dataArchitecture from "./../../images/mono_data_architecture.png";
import eastCoast from "./../../images/mono_manual_east_coast.svg";
import westCoast from "./../../images/mono_manual_west_coast.svg";
import oscSync from "./../../images/mono_manual_osc_sync.svg";
import schemaOsc from "./../../images/mono_manual_schematic_osc.svg";
import schemaFilter from "./../../images/mono_manual_schematic_filter.svg";
import schemaAmp from "./../../images/mono_manual_schematic_amp.svg";
import schemaModulation from "./../../images/mono_manual_schematic_modulation.svg";
import schemaPatch1 from "./../../images/mono_manual_schematic_patch_1.svg";
import schemaPatch2 from "./../../images/mono_manual_schematic_patch_2.svg";
import schemaPatch3 from "./../../images/mono_manual_schematic_patch_3.svg";
import schemaPatch4 from "./../../images/mono_manual_schematic_patch_4.svg";

const monoManualV2Data = {
  chapterLinks: [
   
    {
        name: "#whats-new-on-V2",
        title: "What's new on V2.0 ?",
        class: "title-1"
      },
      {
        name: "#pattern-features",
        title: "Pattern features",
        class: "title-2"
      },
      {
        name: "#patch-load-features",
        title: "Patch loads",
        class: "title-3"
      },
      {
        name: "#quantize-record",
        title: "Quantize record",
        class: "title-3"
      },
      {
        name: "#pattern-morphing",
        title: "Pattern morphing",
        class: "title-3"
      },
      {
        name: "#duophonic-mode",
        title: "Duophonic Mode",
        class: "title-3"
      },
      {
        name: "#Scale-autoquantize",
        title: "Duophonic Mode",
        class: "title-3"
      },
      {
        name: "#sequencer-features",
        title: "Sequencer features",
        class: "title-2"
      },
      {
        name: "#page-copy-paste",
        title: "Page copy/paste",
        class: "title-3"
      },
      {
        name: "#range-copy-paste",
        title: "Randomize a step range",
        class: "title-3"
      },
      {
        name: "#range-autom-randomizer",
        title: "Randomize automation range",
        class: "title-3"
      },
      {
        name: "#step-dice",
        title: "Step dice",
        class: "title-3"
      },
      {
        name: "#automation-modnote",
        title: "Automation on Mod Note",
        class: "title-3"
      },
      {
        name: "#modnote-pitch",
        title: "Mod Note pitch",
        class: "title-3"
      },
      {
        name: "#expressive-features",
        title: "Expressive features",
        class: "title-2"
      },
      {
        name: "#expressive-offset",
        title: "Custom expressive offsets",
        class: "title-3"
      },
      {
        name: "#velocity",
        title: "Velocity",
        class: "title-3"
      },
      {
        name: "#vertical",
        title: "Vertical",
        class: "title-3"
      },
      {
        name: "#pitchbend",
        title: "Pitchbend",
        class: "title-3"
      },
      {
        name: "#aftertouch",
        title: "Aftertouch",
        class: "title-3"
      },
    {
      name: "#quick-start",
      title: "Quick Start",
      class: "title-1"
    },
    {
      name: "#quick-start-panel-layout",
      title: "Panel layout",
      class: "title-2"
    },
    {
      name: "#quick-start-panel-layout-synth-section",
      title: "Synthesis section",
      class: "title-3"
    },
    {
      name: "#quick-start-panel-layout-seq-section",
      title: "Sequencer section",
      class: "title-3"
    },
    {
      name: "#quick-start-connectors",
      title: "Connectors",
      class: "title-2"
    },
    {
      name: "#quick-start-vocabulary",
      title: "Mono vocabulary",
      class: "title-2"
    },
    {
      name: "#quick-start-sound-arch",
      title: "Sound architecture",
      class: "title-2"
    },
    {
      name: "#quick-start-data-arch",
      title: "Data architecture",
      class: "title-2"
    },
    {
      name: "#quick-start-setting-sheet",
      title: "Settings cheat sheet",
      class: "title-2"
    },
    {
      name: "#intro",
      title: "Intro",
      class: "title-1"
    },
    {
      name: "#synth-engine",
      title: "Synthesis Engine",
      class: "title-1"
    },
    {
      name: "#synth-engine-intro",
      title: "Intro",
      class: "title-2"
    },
    {
      name: "#synth-engine-oscillator-block",
      title: "Oscillator block",
      class: "title-2"
    },
    {
      name: "#synth-engine-filter-block",
      title: "Filter block",
      class: "title-2"
    },
    {
      name: "#synth-engine-amplifier",
      title: "Amplifier and main envelope",
      class: "title-2"
    },
    {
      name: "#synth-engine-master-volume",
      title: "Master Volume",
      class: "title-2"
    },
    {
      name: "#modulation",
      title: "Modulation",
      class: "title-1"
    },
    {
      name: "#modulation-intro",
      title: "Intro",
      class: "title-2"
    },
    {
      name: "#modulation-contextual",
      title: "Contextual modulators",
      class: "title-2"
    },
    {
      name: "#modulation-envelope",
      title: "X-Envelope",
      class: "title-2"
    },
    {
      name: "#modulation-modulator",
      title: "X-Modulators",
      class: "title-2"
    },
    {
      name: "#modulation-example",
      title: "A few examples",
      class: "title-2"
    },
    {
      name: "#modulation-kick",
      title: "Kick drum",
      class: "title-3"
    },
    {
      name: "#modulation-phase",
      title: "Evolving phase",
      class: "title-3"
    },
    {
      name: "#modulation-pinged",
      title: "Pinged FM",
      class: "title-3"
    },
    {
      name: "#modulation-filter",
      title: "Filter FM",
      class: "title-3"
    },
    {
      name: "#sequencer",
      title: "Sequencer",
      class: "title-1"
    },
    {
      name: "#sequencer-intro",
      title: "Intro",
      class: "title-2"
    },
    {
      name: "#sequencer-projects-and-basic",
      title: "Projects and patterns",
      class: "title-2"
    },
    {
      name: "#sequencer-projects-and-basic-projects",
      title: "Projects",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-patterns",
      title: "Patterns",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-pattern-control",
      title: "Pattern control",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-pattern-length",
      title: "Pattern length",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-tempo",
      title: "Tempo",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-play-styles",
      title: "Play styles",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-play-modes",
      title: "Play modes",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-live-mode",
      title: "Live mode",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-loop-mode",
      title: "Loop mode",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-song-mode",
      title: "Song mode",
      class: "title-3"
    },
    {
      name: "#sequencer-projects-and-basic-patchless-pattern",
      title: "Patchless pattern",
      class: "title-3"
    },
    {
        name: "#sequencer-pattern-morphing",
        title: "Pattern morphing",
        class: "title-3"
      },
      {
        name: "#sequencer-duonote-mode",
        title: "Duophonic mode",
        class: "title-3"
      },
    {
      name: "#sequencer-editing",
      title: "Pattern editing",
      class: "title-2"
    },
    {
      name: "#sequencer-editing-mini-keyboard",
      title: "Mini keyboard",
      class: "title-3"
    },
    {
      name: "#sequencer-editing-adding-note",
      title: "Adding notes",
      class: "title-3"
    },
    {
      name: "#sequencer-editing-recording-notes",
      title: "Recording notes",
      class: "title-3"
    },
    {
      name: "#sequencer-editing-sh-style",
      title: "SH-Style sequencing",
      class: "title-3"
    },
    {
      name: "#sequencer-editing-change-pitch",
      title: "Edit note pitch",
      class: "title-3"
    },
    {
      name: "#sequencer-editing-note-length",
      title: "Edit note length",
      class: "title-3"
    },
    {
      name: "#sequencer-step",
      title: "Step parameters",
      class: "title-3"
    },
    {
      name: "#sequencer-step-accent",
      title: "Accent",
      class: "title-3"
    },
    {
      name: "#sequencer-step-accent-param",
      title: "Accent parameters",
      class: "title-3"
    },
    {
      name: "#sequencer-step-slide",
      title: "Slide",
      class: "title-3"
    },
    {
      name: "#sequencer-step-slide-rate",
      title: "Slide Rate",
      class: "title-3"
    },
    {
      name: "#sequencer-step-param",
      title: "Microshift probability and ratchet",
      class: "title-3"
    },
    {
      name: "#sequencer-step-mutes",
      title: "Step mutes",
      class: "title-3"
    },
    {
      name: "#sequencer-param-offset",
      title: "Parameter offsets or automation",
      class: "title-2"
    },
    {
      name: "#sequencer-param-offset-visual",
      title: "Visualisation",
      class: "title-3"
    },
    {
      name: "#sequencer-param-offset-add",
      title: "Adding parameter offsets",
      class: "title-3"
    },
    {
      name: "#sequencer-param-offset-record",
      title: "Recording parameter offsets",
      class: "title-3"
    },
    {
      name: "#sequencer-expressive-param-offset",
      title: "Custom expressive parameter offsets",
      class: "title-3"
    },
    {
        name: "#velocity",
        title: "Velocity",
        class: "title-3"
    },
    {
        name: "#vertical",
        title: "Vertical",
        class: "title-3"
    },  
    {
        name: "#pitchbend",
        title: "Pitchbend",
        class: "title-3"
    },
    {
        name: "#aftertouch",
        title: "Aftertouch",
        class: "title-3"
    },
    {
      name: "#sequencer-unlink-env",
      title: "Unlink X-Env Sequence",
      class: "title-2"
    },
    {
      name: "#sequencer-copy",
      title: "Copy paste and clear",
      class: "title-2"
    },
    {
      name: "#sequencer-undo",
      title: "Undo/redo",
      class: "title-2"
    },
    {
      name: "#sequencer-settings",
      title: "Pattern settings",
      class: "title-2"
    },
    {
      name: "#sequencer-settings-scale",
      title: "Scale and root note",
      class: "title-3"
    },
    {
      name: "#sequencer-settings-custom-scale",
      title: "Custom scales",
      class: "title-3"
    },
    {
        name: "#Scale-autoquantize",
        title: "Scale autoquantize",
        class: "title-3"
    },
    {
      name: "#sequencer-settings-transpose",
      title: "Transpose",
      class: "title-3"
    },
    {
      name: "#sequencer-settings-beat-div",
      title: "Beat division",
      class: "title-3"
    },
    {
      name: "#sequencer-settings-swing",
      title: "Swing",
      class: "title-3"
    },
    {
      name: "#sequencer-mod-note",
      title: "Mod note mode",
      class: "title-2"
    },
    {
        name: "#sequencer-mod-note-pitch",
        title: "Mod Note pitch",
        class: "title-3"
    },
    {
        name: "#sequencer-mod-note-autom",
        title: "Automation on Mod Note",
        class: "title-3"
    },
    {
      name: "#sequencer-mod-note-mutes",
      title: "Mod note mutes",
      class: "title-3"
    },
    {
      name: "#sequencer-mod-note-copy",
      title: "Copy/Paste operations",
      class: "title-3"
    },
    {
      name: "#randomizer",
      title: "Randomizer",
      class: "title-1"
    },
    {
      name: "#randomizer-page",
      title: "Page randomizer",
      class: "title-2"
    },
    {
      name: "#randomizer-pitch",
      title: "Pitch randomizer",
      class: "title-2"
    },
    {
      name: "#randomizer-dice",
      title: "Step dice",
      class: "title-2"
    },
    {
      name: "#randomizer-step",
      title: "Step randomizer",
      class: "title-2"
    },
    {
      name: "#randomizer-parameter",
      title: "Parameter randomizer",
      class: "title-2"
    },
    {
        name: "#randomizer-range",
        title: "Randomize a step range",
        class: "title-2"
      },
    {
        name: "#range-autom-randomizer",
        title: "Randomize automation range",
        class: "title-2"
    },
    {
        name: "#randomizer-accent",
        title: "Accent and slide randomizer",
        class: "title-2"
    },
    {
      name: "#settings",
      title: "Project settings",
      class: "title-1"
    },
    {
      name: "#settings-midi",
      title: "MIDI/Clock",
      class: "title-2"
    },
    {
      name: "#settings-pot",
      title: "Pot mode",
      class: "title-2"
    },
    {
      name: "#settings-bend",
      title: "Bend rg",
      class: "title-2"
    },
    {
      name: "#settings-cv2",
      title: "CV2 src",
      class: "title-2"
    },
    {
      name: "#settings-trigger",
      title: "Trigger in",
      class: "title-2"
    },
    {
      name: "#update",
      title: "Update and calibration",
      class: "title-1"
    },
    {
      name: "#update-firmaware",
      title: "Updating firmware",
      class: "title-2"
    },
    {
      name: "#update-oscillators",
      title: "Oscillators calibration",
      class: "title-2"
    },
    {
      name: "#update-resonance",
      title: "Resonance calibration",
      class: "title-2"
    },
    {
      name: "#update-CV",
      title: "CV Calibration",
      class: "title-2"
    },
    {
      name: "#midi",
      title: "Midi implementation",
      class: "title-1"
    },
    {
      name: "#midi-velocity",
      title: "Velocity",
      class: "title-2"
    },
    {
      name: "#midi-cc",
      title: "Control change",
      class: "title-2"
    },
    {
      name: "#midi-cc-table",
      title: "CC parameter table",
      class: "title-3"
    },
    {
      name: "#midi-pc",
      title: "Program change",
      class: "title-2"
    },
    {
      name: "#midi-dump",
      title: "Program dump/receive",
      class: "title-2"
    }
  ],
  content: (
    <>
      <div className="download-link-container">
        <Link to={"/mono/manualV1"} className="download-link">
          Go to V1 manual page
        </Link>
        <a
          className="download-link"
          href="https://storage.googleapis.com/norand_public_files/Mono_Shortcuts_Sheet.pdf"
        >
          <AiFillFilePdf size={"40px"} style={{ "padding-right": "10px" }} />
          Cheat sheet
        </a>
        <a
          className="download-link"
          href="https://storage.googleapis.com/norand_public_files/FirmwareV2.pdf"
        >
          <AiFillFilePdf size={"40px"} style={{ "padding-right": "10px" }} />
          V2 New Feature sheet
        </a>
        <a
          className="download-link"
          href="https://storage.googleapis.com/norand_public_files/NorandV2manual.pdf"
        >
          <AiFillFilePdf size={"40px"} style={{ "padding-right": "10px" }} />
          PDF
        </a>
        <a
          className="download-link"
          href="https://storage.googleapis.com/norand_public_files/mono_V2.2.0r.zip"
        >
          <AiOutlineCloudDownload
            size={"40px"}
            style={{ "padding-right": "10px" }}
          />
          Firmare V2.2.0r
        </a>
      </div>
<h2 id="whats-new-on-V2" manual-section-trigger="true">
        What's new on V2.0 ?
</h2>

      <p>
         Firmware V2.0 is a huge amount of work since the 
         architecture had to be completly rethink, redesigned and look now to a further way, 
         considering the next Norand products.
       </p>
       <p>
         There are tons of cosmetic UI changes such as the playhead, parameter offsets visualization etc.
         Setting offset parameters is not relative to the currrent potentiometer position anymore, 
         but to the center position. Although it was handy to start record automation 
         or place step locks without jumping to a position, it was pretty much impossible 
         to know exactly what was the starting position, so you needed to only trust your 
         ears anyway. Starting from the middle allows to use the maximum range of offset at any time.
      </p>

    <h3 id="pattern-features" manual-section-trigger="true">
        Pattern features
    </h3>

      <h4 id="patch-load-features" manual-section-trigger="true">
         Patch load
      </h4>
       <p> 
         Patch load on pattern shift is deffered to the first trig of newly loaded pattern.
         Therefore long note aren’t silenced at the end of the ending pattern anymore.
       </p>
        
      <h4 id="quantize-record" manual-section-trigger="true">
         Quantize record
      </h4>
       <p>
         Time quantized record is enabled by default but can be disabled. Press [FUNC] + [Bend Rg], select 
         [PAGE A] to disable and [PAGE B] to enable it.
       </p>

      <h4 id="pattern-morphing" manual-section-trigger="true">
         Pattern morphing
      </h4>
       <p>
        You can now morph between the patch and content of 2 patterns.
        To select and load the “morphing pattern”, in pattern selection mode, press and hold [FUNC] +
        [PATTERN], and select the morphing pattern. The morphing pattern blinks.
        Hold [FUNC] and use the [CUTOFF] knob to morph between the two pattern : go from your active
        pattern fully CCW to the morphing pattern full CW. When reaching full CW position (main pattern
        silent, morph pattern full), the two patterns will swap : the main pattern will become the morph
        and vice versa. The previous morph pattern is now active and editable. To morph back, you need to
        go back to full CCW position and proceed !
        You can save the current morph patch in a new pattern : go to pattern mode, hold [RECORD] and
        press a pattern slot. The patch will be created there, it will copy pattern A or B steps depending
        on your morph position.
       </p>
        
      <h4 id="duophonic-mode" manual-section-trigger="true">
         Duophonic Mode
      </h4>
       <p>
         To enable the mode press [FUNC] + [SWING] then [PAGE B] to enable, [PAGE A] to disable. 
         In duophonic mode you can set a pitch for each oscillator.
         Hold two notes on the minikeyboard to set the duophonic pitch and add duophonic notes with the [SEQ] switches. 
         Make a step duophonic : hold the first pitch and the second pitch and press a [SEQ] the inverse is possible too.
       </p>

      <h4 id="Scale-autoquantize" manual-section-trigger="true">
         Scale autoquantize
      </h4>
       <p>
         When scale autoquantize is enabled, changing the scale
         will move the notes of the pattern according to the new scale, it uses a smart
         algorithm that works pretty well even on custom scale. The algorithm is however
         destructive : if you go from a 7 note scale to a custom scale of 4 notes and switch
         back to a 7 note scale, you wont get back the same pattern.
       </p>


    <h3 id="sequencer-features" manual-section-trigger="true">
        Sequencer features
    </h3>

      <h4 id="page-copy-paste" manual-section-trigger="true">
         Page copy/paste
      </h4>
       <p>
         You can now copy a page and paste it on an other page without having to set the pattern length.
         Hold [FUNC] + [COPY] and press the [PAGE] to copy, then hold [FUNC] + [PASTE] and press the [PAGE] 
         where you want to paste.
       </p>
      
      <h4 id="range-copy-paste" manual-section-trigger="true">
         Range copy/paste
      </h4>
       <p>
         To copy a range of steps, hold [FUNC] + [COPY], hold 
         the start [SEQ] of the range and press the end [SEQ]. Then 
         hold [FUNC] + [PASTE], the starting [SEQ] step where you want to paste, and then the end [SEQ].
       </p>

      <h4 id="range-randomizer" manual-section-trigger="true">
         Randomize a step range
      </h4>
       <p>
         To randomize a range of step, hold [TEMPO] + [FUNC], 
         hold the [SEQ] starting the range, and then press the 
         [SEQ] ending the range, release, and voila ! 
         It will randomize all parameters of mixer, filter and envelope section.
       </p>

      <h4 id="range-autom-randomizer" manual-section-trigger="true">
         Randomize automation range
      </h4>
       <p>
         Randomize automation range : hold [TEMPO] + [FUNC], set the desired range by 
         holding the first [SEQ] and pressing the end [SEQ]. Release the [SEQ] switches (not 
         [TEMPO] and [FUNC]) then turn the desired knobs parameter left and right to set the 
         randomisation range, just like the randomize automation feature.
       </p>

      <h4 id="step-dice" manual-section-trigger="true">
         Step dice
      </h4>
       <p>
         Since you can now randomize step ranges, step dice shortcut has 
         changed, you need to hold [TEMPO] + [FUNC], press the ending [SEQ], and then the first
         [SEQ] of the range (the order is important).
       </p>
        
      <h4 id="automation-modnote" manual-section-trigger="true">
         Automation on Mod Note
      </h4>
       <p>
         Mod Note notes are not “set in stone” as they used to be, they 
         can now be affected by automations.
       </p>
        
      <h4 id="modnote-pitch" manual-section-trigger="true">
         Mod Note pitch
      </h4>
       <p>
         You can edit a Mod Note note pitch : hold the mod note [KEY] and press 
         [UP] or [DOWN] to set the mod note octave. Hold [UP] + [DOWN] and press a [KEY] 
         to set the current modnote semitone. Hold a step [SEQ] that contains a modnote and 
         press [UP] or [DOWN] to change its pitch.
       </p>
        
        
    <h3 id="expressive-features" manual-section-trigger="true">
         Expressive features
    </h3>
      
      <h4 id="expressive-offset" manual-section-trigger="true">
         Custom expressive offsets
      </h4>
       <p>
         V2.0 allows you to set velocity, pitchbend, aftertouch, vertical. Each of these MIDI parameters 
         can affect the patch according to custom offsets on any and all parameters and their modulation values, 
         just like the accent on V1. To check nor set these offset, a switch needs to be held, when the switch 
         is held the LED brightness of the parameter shows the offset “strength”. Offset can be negative, 
         a potentiometer at center position means no offset, full CCW means maximum negative offset, 
         full CW means maximum positive offset.
       </p>
       <p>Here are the 4 switches :</p>
       <p> 
        <ul> 
          <li>
          [SLIDE] - Velocity
          </li>
          <li>
          [UP] - Aftertouch
          </li>
          <li>
          [DOWN] - Vertical (CC74)
          </li>
          <li>
          [FOLLOW] - Pitch (pitchbend)
          </li>
        </ul>
       </p>
       <p>
         These MIDI parameters can be recorded on each steps, like automation when played from an external keyboard 
         or sequencer. There are also ways to edit velocity and Vertical (CC74) automation directly on the synth, as follow.
       </p>

       <h4 id="velocity" manual-section-trigger="true">
         Velocity
      </h4>
       <p>
         To edit a step velocity, hold [FUNC] + the [SEQ] step, and use the X-Mod
         amount pot to set the velocity from 0 at full CCW to 127 at full CW. When record is
         enabled, you can hold [FUNC] and move the X-Mod amount pot to record velocity
         values on the fly.
       </p>

       <h4 id="vertical" manual-section-trigger="true">
         Vertical
      </h4>
       <p>
         Vertical or  CC74 is often used for the vertical (Y) axis on expressive keyboard.
         To edit the CC74 of a step (regardless if there is a trig on that note or not), hold
         [FUNC] + the [SEQ] step, and use the X-Mod Rate pot to set the CC74 value, from 0
         at full CCW to 127 at full CW. When record is enabled, you can hold [FUNC] and
         move the X-Mod amount pot to record CC74 values on the fly.
       </p>


      <h4 id="pitchbend" manual-section-trigger="true">
         Pitchbend
      </h4>
       <p>
         A pitch offset makes the parameter follow the pitch played on the synth (note + pitchbend). 
         By default the 2 oscillators and the filter have an offset of 1 semitone by semitone. 
         The filter tracking can still be enabled/disabled with the follow switch. 
         On the two oscillators on the filter the offset is not linear but quantized, 
         this allow for microtonal/macrotonal playing. At center position the oscs/filter don’t track, 
         there are then 6 positions on the positive and negative side : ⅛ semitone - ¼ semitone - ½ semitone 
         - 1 semitone - 1 tone - 2 tone.
       </p>

       <h4 id="aftertouch" manual-section-trigger="true">
         Aftertouch
      </h4>
       <p>
         Aftertouch is the only parameter that cannot be set directly on Mono, but can be recorded via MIDI. 
         Press [DELETE] + [UP] to clear aftertouch automations.
       </p>


<h2 id="quick-start" manual-section-trigger="true">
        Quick-Start
</h2>

      <p>
         If you are eager to start making music with Mono right now, this couple
         of pages should get you started.
      </p>
      <h3 id="quick-start-panel-layout" manual-section-trigger="true">
        Panel Layout
      </h3>
      <img
        className="manual-img"
        id="panel-img"
        src={manualPanel}
        alt="mono panel"
      />
      <h4
        id="quick-start-panel-layout-synth-section"
        manual-section-trigger="true"
      >
        Synthesis section
      </h4>
      <ol id="panel-layout">
        <li>
          <span className="strong-1">Oscillator section :</span> 2 oscillators
          with quantized frequency, bipolar detune and continuously variable
          waveform controls. Mod section with Thru-Zero Frequency Modulation
          (TZFM) and hard-sync from oscillator 1 to oscillator 2.
        </li>
        <li>
          <span className="strong-1">Mixer section :</span> set oscillators
          level. Above a certain oscillator level, the filter will softly
          saturate said oscillator, resulting in interesting timbres.
        </li>
        <li>
          <span className="strong-1">Filter section :</span> state Variable
          Filter with cutoff, resonance, continuously variable state, and
          bipolar envelope amount controls, as well as a keyboard tracking
          “Follow” switch. Filter is self-resonant at maximum resonance.
        </li>
        <li>
          <span className="strong-1">Main envelope :</span> a classic ADSR
          envelope. It is rettringering, meaning a new note will restart the
          cycle.
        </li>
        <li>
          <span className="strong-1">Output volume :</span> pretty
          self-explanatory, although it's a digital control so it can also be
          modulated (Audio rate amplitude modulation ? Oh yes.)
        </li>
        <li>
          <span className="strong-1">X-Modulator :</span> parameter-dedicated
          modulation oscillators with 5 types - low frequency, low frequency
          synced, audio-rate, audio-rate quantized -, 5 waves - sine, triangle,
          square, sawtooth, S&H-, rate control and bipolar amount control.
        </li>
        <li>
          <span className="strong-1">X-Envelope :</span> parameter-dedicated AD
          envelope with attack, decay, and amount controls. Assignable to X-Mod
          amount.
        </li>
      </ol>
      <p>
        Each of the 18 synthesizer parameters have their own dedicated X-Mod and
        X-Env. To access a parameter's dedicated modulation, just move it a bit.
        If you want to select the parameter without changing its value, hold
        [FUNC] and move the knob.
      </p>
      <h4
        id="quick-start-panel-layout-seq-section"
        manual-section-trigger="true"
      >
        Sequencer section
      </h4>

      <ol>
        <li>
          <span className="strong-1">Menu switches :</span>
          <ul>
            <li>
              <span className="strong-2">Run :</span> start and stop the
              sequencer player
            </li>
            <li>
              <span className="strong-2">Pattern :</span> select current pattern
            </li>
            <li>
              <span className="strong-2">Tempo :</span> set tempo using up/down
              switches, step switches, or X-Mod amount knob for vinyl-like speed
              adjust.
            </li>
            <li>
              Hold Func + Tempo to randomize something, see randomize bubble
            </li>
          </ul>
        </li>
        <li>
          <span className="strong-1">Step switches :</span> these 16 switches
          along with the page selection switches allow users to edit the 64
          step-sequence, and access other settings such as length, pattern and
          synth settings.
          <ul>
            <li>
              <span className="strong-2">Add note :</span> press the switch to
              add selected note
            </li>
            <li>
              <span className="strong-2">Edit note length :</span> hold start
              position, then press end position
            </li>
            <li>
              <span className="strong-2">Edit pattern length :</span> hold Func
              and press pattern, then press a step to set the length
            </li>
            <li>
              <span className="strong-2">Change pattern :</span> press pattern,
              press step
            </li>
            <li>
              <span className="strong-2">Manually enter tempo :</span> hold
              tempo, enter digits with steps, release tempo
            </li>
            <li>
              <span className="strong-2">Edit settings :</span> see settings
              cheat sheet
            </li>
          </ul>
        </li>
        <li>
          <span className="strong-1">Mini keyboard :</span> Allow to select the
          note to be added on a step (shown by bright LED). Pressing the switch
          will play the associated note. The LED will reflect the current scale.
        </li>
        <li>
          <span className="strong-1">Menu switches :</span>
          <ul>
            <li>
              <span className="strong-2">Up/Down :</span> select current octave.
              Hold func + Up/Down to rotate pattern. Press the 2 buttons to
              enter Mod Note mode, see mod note bubble.
            </li>
            <li>
              <span className="strong-2">Accent/Glide :</span> Hold and press
              steps to add accent or glide. Hold func and press to undo/redo.
              Every single action on Mono can be undone.
            </li>
            <li>
              <span className="strong-2">Record :</span> enter/leave record
              mode. In record mode, incoming notes from external and internal
              keyboard will be recorded. Also, knobs movements will be recorded
              as automation as well.
            </li>
            <li>
              <span className="strong-2">Delete :</span> Hold delete and press a
              page or step switch, or rotate a knob to delete associated data.
            </li>
          </ul>
        </li>
        <li>
          <span className="strong-1">Page switches :</span> Select current page
        </li>
      </ol>
      <p>
        <span className="strong-2">Settings :</span> Hold Func and press desired
        settings, select value, press Func to exit
      </p>

      <h3 id="quick-start-connectors" manual-section-trigger="true">
        Connectors
      </h3>
      <img
        className="manual-img"
        style={{ "margin-top": "40px" }}
        src={manualPanelBack}
        alt="mono panel back"
      />

      <ol id="connector-list">
        <li>
          <span className="strong-2">DC IN :</span> Use the included PSU power
          adapter connected to a power outlet.
        </li>
        <li>
          <span className="strong-2">POWER :</span> Turns the unit on and off.
        </li>
        <li>
          <span className="strong-2">USB :</span> Use an A to B USB 2.0
          connector cable to a computer host.
        </li>
        <li>
          <span className="strong-2">MIDI OUT :</span> Midi data output, use a
          standard MIDI cable to connect to MIDI In of an external MIDI device.
          Outputs the currently playing sequence.
        </li>
        <li>
          <span className="strong-2">MIDI THRU :</span> Forwards data from MIDI
          IN. Use a standard MIDI cable to connect another MIDI device in the
          chain.
        </li>
        <li>
          <span className="strong-2">MIDI IN :</span> MIDI data input, use a
          standard MIDI cable to connect to MIDI Out of an external MIDI device.
        </li>
        <li>
          <span className="strong-2">ACCENT OUT :</span> Outputs a 5V gate
          signal for each accented steps, use a standard Eurorack cable.
        </li>
        <li>
          <span className="strong-2">CV2 :</span> Outputs one of the
          configurable sources as an analog CV, use a standard Eurorack cable.
        </li>
        <li>
          <span className="strong-2">GATE OUT :</span> Outputs the current
          pattern note trigs as a 5V gate signal, use a standard ¼” Eurorack
          cable.
        </li>
        <li>
          <span className="strong-2">CV OUT :</span> Outputs the current pattern
          pitch as a 1V/Oct signal, use a standard Eurorack cable.
        </li>
        <li>
          <span className="strong-2">RESET INPUT :</span> CV clock reset input,
          use a standard Eurorack cable.
        </li>
        <li>
          <span className="strong-2">CLOCK INPUT :</span> CV clock pulse input,
          use a standard Eurorack cable.
        </li>
        <li>
          <span className="strong-2">MAIN OUTPUT :</span> Use a ¼” TRS phone
          plug (Balanced connection)
        </li>
      </ol>
      <h3 id="quick-start-vocabulary" manual-section-trigger="true">
        Mono vocabulary
      </h3>
      <p>
        <span className="strong-1">Project :</span> Top structure of mono data
        architecture, This holds 64 patterns, global settings 40 Mod Notes and 4
        custom scales.
      </p>
      <p>
        <span className="strong-1">Pattern :</span> A sequence of steps to be
        played in a loop
      </p>
      <p>
        <span className="strong-1">Step :</span> An element holding information
        to be sent to the synthesis engine to “play” sound.
      </p>
      <p>
        <span className="strong-1">Synth parameter :</span> A parameter directly
        controlling the internal CVs of the underlying analog synthesis engine,
        such as Wave, Freq, Cutoff … Even though the envelope is digital,
        envelope parameters are considered synth parameters as well.
      </p>
      <p>
        <span className="strong-1">Modulation parameter :</span> A parameter
        that modulates a given synth parameter. Each synth parameters have
        dedicated modulation parameters.
      </p>
      <p>
        <span className="strong-1">Patch :</span> All synth and modulation
        parameters that form a particular sound. Each pattern holds its own
        patch.
      </p>
      <p>
        <span className="strong-1">Note trig :</span> Information held in a
        step, triggering the synth engine with a given note.
      </p>
      <p>
        <span className="strong-1">Parameter offset :</span> Information held in
        a step, offsetting the value of a given parameter for the duration of
        that step.
      </p>
      <h3 id="quick-start-sound-arch" manual-section-trigger="true">
        Mono sound architecture
      </h3>
      <img
        className="manual-img"
        src={soundArchitecture}
        alt="Mono sound architecture"
      />
      <h3 id="quick-start-data-arch" manual-section-trigger="true">
        Mono data architecture
      </h3>
      <img
        className="manual-img"
        src={dataArchitecture}
        alt=" Mono data architecture"
      />
      <Row className="row-bubble">
        <Col lg={6} md={12} className="card-col">
          <Card>
            <Card.Title>
              <FaDice size={"40px"} style={{ "padding-right": "10px" }} />
              Randomizer
            </Card.Title>
            <Card.Text>
              Hold [FUNC] + [TEMPO] and :
              <ul>
                <li>
                  Press a [PAGE] key : add between 1 and 4 random notes to the
                  page, the added note are always in scale.
                </li>
                <li>
                  Press a [SEQ] key : Randomize every parameter of said step
                  except its pitch
                </li>
                <li>
                  Press [GLIDE] or [ACCENT] key to add random glides and accents
                </li>
                <li>Move a parameter's knob to create a random automation</li>
                <li>
                  Remember you can always undo if you don't like what you hear
                </li>
              </ul>
            </Card.Text>
          </Card>
        </Col>
        <Col lg={6} md={12} className="card-col">
          <Card>
            <Card.Title>
              <FaSlidersH size={"40px"} style={{ "padding-right": "10px" }} />
              Mod note mode
            </Card.Title>
            <Card.Text>
              In Mod Note mode, the keyboard no longer act as chromatic, each of
              the 8 bottom mini keyboard [NOTE] keys has its own set of
              parameters, its own timbre in a way.
            </Card.Text>
            <Card.Text>
              Each project has 5 pages of Mod notes, scroll with [UP] or [DOWN]
              key. When the mode is activated, both [UP] and [DOWN] key LED are
              on.
            </Card.Text>
            <Card.Text>
              To edit one of the moded note, hold a mini-keyboard key and set
              its parameter. You can then add steps of the selected moded note,
              or play live and record it.
            </Card.Text>
          </Card>
        </Col>
      </Row>
      <h3 id="quick-start-setting-sheet" manual-section-trigger="true">
        Settings cheat sheet
      </h3>

      <p>
        <span className="strong-1">Play Style :</span> Set play style on the
        play mode setting :
      </p>
      <p>
        <Row className="row-settings">
          <div className="settings-col">
            <span className="param-enum">1</span> Forward (Default)
            <br />
            <span className="param-enum">2</span> Reverse
            <br />
            <span className="param-enum">3</span> Synced Pendulum
            <br />
            <span className="param-enum">4</span> Pendulum
            <br />
            <span className="param-enum">5</span> Drunk (2 Forward, 1 backward)
            <br />
            <span className="param-enum">6</span> Reverse drunk
            <br />
            <span className="param-enum">7</span> Random Drunk (75% chance
            forward, 25% backward)
            <br />
            <span className="param-enum">8</span> Reverse Random Drunk
            <br />
            <span className="param-enum">9</span> Random
            <br />
          </div>
        </Row>
      </p>
      <p>
        <span className="strong-1">Play Modes :</span> Set play modes with the
        [PAGE] keys on play mode setting.
      </p>
      <p>
        <Row className="row-settings">
          <div className="settings-col">
            <span className="param-enum">A</span> Sequential (default)
            <br />
            <span className="param-enum">B</span> Direct Jump
            <br />
            <span className="param-enum">C</span> Direct Start
            <br />
          </div>
        </Row>
      </p>
      <p>
        <span className="strong-1">Swing :</span> Set swing value. Default is 9
        (no swing). Greater value add swing and lower value add shuffle.
      </p>
      <p>
        <span className="strong-1">Scale :</span> Set root note with [NOTE]
        keys, and scale with the [SEQ] keys.
      </p>
      <p>
        <Row className="row-settings">
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">1</span> Chromatic (default)
            <br />
            <span className="param-enum">2</span> Major
            <br />
            <span className="param-enum">3</span> Melodic minor
            <br />
            <span className="param-enum">4</span> Harmonic minor
            <br />
            <span className="param-enum">5</span> Arabic
            <br />
            <span className="param-enum">6</span> Dorian
            <br />
            <span className="param-enum">7</span> Aeolian
            <br />
            <span className="param-enum">8</span> Phrygian
            <br />
          </Col>
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">9</span> Gypsy
            <br />
            <span className="param-enum">10</span> Mixolidian
            <br />
            <span className="param-enum">11</span> Romanian minor
            <br />
            <span className="param-enum">12</span> Gypsy minor
            <br />
            <span className="param-enum">13</span> japanese
            <br />
            <span className="param-enum">14</span> Spanish
            <br />
            <span className="param-enum">15</span> blues
            <br />
          </Col>
        </Row>
      </p>
      <p>
        <span className="strong-1">Transpose :</span> Set transpose with [NOTE]
        keys for semi-tone transposition and [SEQ] key for octave transposition,
        [SEQ] key 8 is the default value.
      </p>
      <p>
        <span className="strong-1">Beat div :</span> Set the number of step per
        beat :
      </p>
      <p>
        <Row className="row-settings">
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">1</span> 1:16
            <br />
            <span className="param-enum">2</span> 1:12
            <br />
            <span className="param-enum">3</span> 1:8
            <br />
            <span className="param-enum">4</span> 1:6
            <br />
            <span className="param-enum">5</span> 1:4 (Default)
            <br />
            <span className="param-enum">6</span> 1:3
            <br />
          </Col>
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">7</span> 1:2
            <br />
            <span className="param-enum">8</span> 2:3
            <br />
            <span className="param-enum">9</span> 1:1
            <br />
            <span className="param-enum">10</span> 3:2
            <br />
            <span className="param-enum">11</span> 2:1
            <br />
          </Col>
        </Row>
      </p>
      <p>
        <span className="strong-1">MIDI/Clock :</span> Set MIDI channel with
        [SEQ] key, and clock source with [PAGE] key.
      </p>
      <p>
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          A
        </span>{" "}
        USB
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          B
        </span>{" "}
        MIDI
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          C
        </span>{" "}
        CV
      </p>
      <p>
        <span className="strong-1">Pot Mode :</span> Sets potentiometer mode.
      </p>
      <p>
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          1
        </span>{" "}
        Jump
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          2
        </span>{" "}
        Passthru
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          3
        </span>{" "}
        Relative
      </p>
      <p>
        <span className="strong-1">Bend Rg :</span> Sets pitch bend range from 1
        to 16 semitones with [SEQ] key.
      </p>
      <p>
        <span className="strong-1">CV2 Src :</span> Sets the CV2 output source.
      </p>
      <p>
        <Row className="row-settings">
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">1</span> Osc1 freq
            <br />
            <span className="param-enum">2</span> Osc2 freq
            <br />
            <span className="param-enum">3</span> Cutoff
            <br />
            <span className="param-enum">4</span> Envelope
            <br />
            <span className="param-enum">5</span> Output level
            <br />
          </Col>
          <Col lg={6} md={12} className="settings-col">
            <span className="param-enum">6</span> Clock out 1/1
            <br />
            <span className="param-enum">7</span> Clock out 1/4
            <br />
            <span className="param-enum">8</span> Clock out 1/8
            <br />
            <span className="param-enum">9</span> Clock out 1/16
            <br />
          </Col>
        </Row>
      </p>
      <p>
        <span className="strong-1">Clock/Trig in :</span> In the CV2 source
        settings, page A and B are used to set the clock input behaviour.
        Default is Clock input (A), B transforms the input into a trigger input.
      </p>
      <p>
        <span className="strong-1">Param Snd :</span> Enable/Disable CC
        parameter send.
      </p>
      <p>
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          1
        </span>{" "}
        Disabled
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          2
        </span>{" "}
        Enabled
      </p>
      <p>
        <span className="strong-1">Pgm Rcv :</span> Wait to receive a project
        file as sysex.
      </p>
      <p>
        <span className="strong-1">Pgm Dump :</span> Dump the current project as
        a sysex file
      </p>

      <h2 id="intro" manual-section-trigger="true">
        Intro
      </h2>

      <p>
        What is Norand Mono ? Well, (not so) simply put, it is an analog
        monophonic synthesizer with a large set of performance-oriented digital
        features. At the heart of this small synthesizer lies an all analog
        signal path, with uniquely designed circuit blocks. The circuits are not
        cloned from anything, they are original designs (at least to my
        knowledge, of course). Each of these analog blocks are
        voltage-controlled by powerful Digital-to-Analog converters, which allow
        for high-definition, independent audio-rate controls and modulations.
        The “brain” of the synth is a last-generation microcontroller running at
        a whooping 480MHz, which allows smooth computation of these voltage
        source outputs.
      </p>
      <p>Mono's interface is split in three distinctive blocks :</p>
      <p>
        The synthesis block : where most of the sound timbre is crafted. This is
        the top part of Mono - the synthesis block controls synth parameters
        such as osc frequency, filter cut-off, etc, are called synth parameters.
      </p>
      <p>
        The modulation block : where you can program modulations for synth
        parameters. This is not a single LFO and Envelope - every single
        synthesis parameter has its own dedicated modulation block. The
        modulation block controls are called modulation parameters.
      </p>
      <p>
        The sequencer block : where you can record, edit, and play sequences of
        notes, parameters, modulations … On mono, everything is “sequencable”.
      </p>
      <p>
        Now anyone with a decent understanding of synthesis can just power on
        Mono and start making music. However, I want this manual to toroughly
        explain each element. The synthesis part of this manual explains a lot
        of what Mono can do that other synths can't do, it's pretty technical
        but it's an important step to master the synth.
      </p>
      <p>“So you expect me to read?!”</p>
      <p>
        Well … yes ! Mono is designed to be programmed by the user from scratch.
        The 303-like look is not there just because I find it beautiful. What
        was amazing with these old-school synths was the spontaneity, ease of
        use, and instant fun. Now of course the more complicated and feature
        rich the synth is, the less spontaneous it could be. Therefore, the
        boring part : RTFM. The point of this manual is not just to give you a
        list of the features and step-by-step instructions, but to highlight and
        demonstrate how you can use these features in real world sound-design
        examples!
      </p>
      <h2 id="synth-engine" manual-section-trigger="true">
        Synthesis Engine
      </h2>
      <h3 id="synth-engine-intro" manual-section-trigger="true">
        Intro
      </h3>
      <p>
        By the looks of it, Mono has everything of an East Coast synthesizer.
        There is a clear signal flow from left to right, starting from the
        oscillators, through the filter, and finally to the amplifier. But the
        contextual modulations (X-Modulator and X-Envelope) let any user alter
        each synth parameter so deeply that one can effectively use west coast
        synthesis techniques to craft the timbre. Indeed, one can easily make a
        good sounding patch using a single oscillator with Mono ! Let's dive
        into each part.
      </p>
      <Row className="row-bubble">
        <Col lg={6} md={12} className="col-lg-6 card-col">
          <Card>
            <Card.Title>East coast synthesis</Card.Title>
            <Card.Img src={eastCoast} alt="east coast" />
            <Card.Text>
              East coast synthesis usually describe subtractive synthesis
              techniques, where the sound designers start with an oscillator
              rich in harmonics, and then shape the sound by removing
              (subtracting) harmonics with filters.
            </Card.Text>
          </Card>
        </Col>
        <Col lg={6} md={12} className="col-lg-6 card-col">
          <Card>
            <Card.Title>West coast synthesis</Card.Title>
            <Card.Img src={westCoast} alt="west coast" />
            <Card.Text>
              West Coast synthesis describes a different approach. It tipically
              feature oscillators with simple shapes, that are then heavily
              modulated using FM and waveshaping techniques to create complex
              timbre.
            </Card.Text>
          </Card>
        </Col>
      </Row>
      <h3 id="synth-engine-oscillator-block" manual-section-trigger="true">
        Oscillator block
      </h3>
      <img
        style={{ maxHeight: "200px", display: "block", margin: "20px auto" }}
        className="manual-img"
        src={schemaOsc}
        alt="oscillator block"
      />
      <p>
        Mono offers 2 analog oscillators with continuously variable waveforms,
        thru-zero frequency modulation, and hard sync. For the electronic geeks
        among us, the oscillators are based around a unique discrete asymmetric
        integrator. In “layman” terms, it means that the triangle core waveform
        is not perfect, it is a bit “skewed”, which gives it and the sinus wave
        a slightly richer harmonic content.
      </p>
      <p>
        Each oscillator has 3 parameters. The big [FREQ] knob adjusts the pitch
        in semitones, from C0 to C8. The [DETUNE] knob has a range of two
        semitones, with a pitch perfect 440Hz tuning in the middle.
      </p>
      <p>
        The [WAVE] parameters smoothly fade from sinus, to triangle, to square
        and finally to sawtooth wave. You basically go from the dullest of
        sounds to the richest in terms of harmonics.
      </p>
      <p>
        The two mod parameters give you additional sound design tools : the
        [SYNC] key synchronizes the wave cycle of oscillator 2 with oscillator
        1; the [TZFM] parameter modulates the frequency of oscillator 2
        <span className="emphasis">· the carrier ·</span> with oscillator 1
        <span className="emphasis">· the modulator ·</span>. It is analog
        thru-zero frequency modulation, which has a very rich distinctive sound.
      </p>
      <p>
        Finally you can adjust the amount of both oscillators fed to the filter
        with [OSC1] and [OSC2] parameters. At high gain, the oscillators
        overdrive the filter, so you can also use this parameter creatively.
      </p>
      <p>
        Although limited compared to other big monosynths (only 2 oscillators ?!
        No noise ?! What is this ?), this oscillator block allows for a huge
        landscape of timbre. This can range from subtle bell-like sounds to very
        harsh saturated noise. All this without even touching contextual
        modulation. Adding the latter makes for a very complex oscillator
        system.
      </p>
      <p>
        Just a simple example : use the X-Modulator at audio rate on the Freq
        parameter of both oscillators - you get a 4-operator hybrid FM synth
        (for normal people, this translates to: “You can do some pretty cool
        stuff with this synth”).
      </p>
      <Row className="row-bubble">
        <Col xl={6} lg={12} className="card-col">
          <Card>
            <Card.Title>Oscillator Sync</Card.Title>
            <img
              className="manual-img"
              style={{ "margin-top": "20px", maxHeight: "200px" }}
              src={oscSync}
              alt="osc sync"
            />
            <Card.Text>
              I'm lazy so here is the wikipedia definition : As one oscillator
              <span className="emphasis">· the master ·</span> finishes a cycle,
              it resets the period of another oscillator
              <span className="emphasis">· the slave ·</span>, forcing the
              latter to have the same base frequency. This can produce a
              harmonically rich sound, the timbre of which can be altered by
              varying the synced oscillator's frequency. And here is a nice
              schematic with sawtooth wave example.
            </Card.Text>
          </Card>
        </Col>
        <Col xl={6} lg={12} className="card-col">
          <Card>
            <Card.Title>Thru-Zero Frequency modulation</Card.Title>
            <Card.Text>
              FM (Frequency Modulation) is a very deep subject with whole books
              written about it, I'll do my best to explain it shortly. Let's
              start with what FM is : the output of one oscillator
              <span className="emphasis">· the modulator ·</span> is used to
              control the frequency of another oscillator
              <span className="emphasis">· the carrier ·</span>. This will in
              turn enrich the harmonic content of the carrier, by effectively
              “spliting” each of it's base harmonic. There are two main type of
              FM : exponential and linear. Unlike exponential FM, linear FM can
              reach zero hertz, which basically stops the oscillators, which is
              not very pleasing in term of musicality. Thru-zero FM alleviate
              this problem by introducing “negative” frequency. When the
              oscilator reaches zero hertz, it will reverse it's cycle and start
              oscillating backward, and when it crosses zero hertz, it will
              reverse again back to “positive” frequencies. Note that I put
              negative and positive in quote, in the real world there is no such
              thing as negative frequency.
            </Card.Text>
          </Card>
        </Col>
      </Row>
      <h3
        className="anchor"
        id="synth-engine-filter-block"
        manual-section-trigger="true"
      >
        Filter block
      </h3>
      <img
        className="manual-img"
        style={{ maxHeight: "200px", display: "block", margin: "20px auto" }}
        src={schemaFilter}
        alt="filter block"
      />
      <p>
        Mono's filter is a resonant filter with low-pass, high-pass and
        band-pass output. Like the oscillator, it is a unique design : discrete
        integrator cells arranged in a three cell 18dB slope state-variable
        filter. It features a stable self oscillation at maximum resonance and
        it is precisely tuned like the oscillators. When driven hard, it
        saturates the input signal asymmetrically
        <span className="emphasis">
          · only the negative voltage is clipped ·
        </span>
        .
      </p>
      <p>
        The [CUTOFF] parameter sets the frequency, from C-1 to C10. Although you
        won't necessarily hear it because it is smoothed, the filter knob is
        quantized to semitones (just the knob, not the modulations). This is a
        controversial feature, but this is the only way to make the filter
        resonance perfectly tuned with the oscillator.
      </p>
      <p>
        The [RESONANCE] parameter goes from a very attenuated cutoff point to
        self-resonant, with lots of nice things in the middle. The resonance
        peak is quite shallow, which allows the user to “scan” the harmonic
        content of the input when swept.
      </p>
      <p>
        The [COLOR] parameters continuously fade from band-pass, to low-pass, to
        high-pass output. On these types of continous outputs, you'll usually
        find band-pass in the middle, but I find that quite boring, so there's
        that. There are some very interesting timbres in between each output.
        For example, put the knob halfway between low-pass and high-pass, and
        you get a resonant all-pass filter !
      </p>
      <p>
        The [FOLLOW] key toggles keyboard follow : when enabled, cutoff
        frequency is linked to the current note pitch.
      </p>
      <p>
        Finally the [ENV AMOUNT] parameter adjusts how much of the main envelope
        contour is applied to the cutoff frequency parameter. It's bipolar : no
        effect in the center position, positive envelope in the clockwise
        direction, and negative envelope in the counter-clockwise direction.
      </p>
      <h3
        className="anchor"
        id="synth-engine-amplifier"
        manual-section-trigger="true"
      >
        Amplifier and main envelope
      </h3>
      <img
        className="manual-img"
        style={{ maxHeight: "200px", display: "block", margin: "20px auto" }}
        src={schemaAmp}
        alt="amplifier"
      />
      <p>
        There is not much to say here, the [VOLUME] parameters surprisingly
        adjust the output volume. The envelope is a (somewhat) classic
        exponential ADSR envelope with no retriggering.
      </p>
      <p>
        There is a case where it doesn't behave like a classic analog envelope
        though : Usually when given a short trigger, an ADSR will perform its
        attack cycle only if very short, and then the release cycle. If the
        trigger is too short or the attack is long, it won't even reach the
        maximum level. If this was the case here, the attack parameter would be
        useless when using the sequencer.
      </p>
      <p>
        Here is how it works instead : when the gate is shorter than the attack
        time, the envelope acts as an AD envelope : it will perform a full
        attack cycle, and then a decay cycle down to 0.
      </p>
      <h3
        className="anchor"
        id="synth-engine-master-volume"
        manual-section-trigger="true"
      >
        Master volume
      </h3>
      <p>
        The volumes are recorded into each patch and mod notes separately which
        make it impossible to adjust the global volume output. Of course we
        needed to address that : there's a "hidden" master volume control, which
        is not recorded into project. To adjust it, hold [FUNC] and turn the
        [VOLUME] knob.
      </p>
      <h2 id="modulation" manual-section-trigger="true">
        Modulation
      </h2>
      <img
        className="manual-img"
        style={{ maxHeight: "200px", display: "block", margin: "20px auto" }}
        src={schemaModulation}
        alt="modulation"
      />
      <h3 id="modulation-intro" manual-section-trigger="true">
        Intro
      </h3>
      <p>
        This is where all the fun begins … Remember your old synth where you get
        to play with one LFO that you can assign to a 2 or 3 parameters ? Those
        were great ! Then the digital era introduced the “Modulation Matrix”
        which are admittedly much better in terms of synthesis possibilities,
        but are kind of a pain in the arse to work with. One of my favourite
        features with software synths is the fact that one can have an unlimited
        amount of modulators for each and every possible synthesis parameter -
        Mono implements this without menu-diving or 200 potentiometers.
      </p>
      <h3 id="modulation-contextual" manual-section-trigger="true">
        Contextual modulators
      </h3>
      <p>
        When you select something in a software instrument, you usually get a
        contextual menu appearing somewhere. Mono's X-modulator and X-envelope
        works in the same way. When you slightly move a parameter's
        potentiometer, it will be selected (a selected parameter is indicated by
        a bright LED). You can then edit that parameter's AD envelope and
        modulator.
      </p>
      <p>
        Every single parameter has its own envelope and modulator with their
        dedicated settings, there are no limitations. That's 18 Modulators and
        14 AD envelopes. the main envelope parameters don't have an envelope,
        that wouldn't make sense.
      </p>
      <p>
        If you have tons of modulation on a patch and you are lost, you can hold
        the [FUNC] key, the potentiometer LED intensity will reflect the
        modulation of each parameter as long as you hold [FUNC].
      </p>
      <h3 id="modulation-envelope" manual-section-trigger="true">
        X-Envelope
      </h3>
      <p>
        The X-Envelopes are AD envelopes triggered by the sequencer's note trig,
        incoming MIDI, or their very own trig sequence. Like the main envelope,
        they always complete their attack cycle before going to the decay cycle.
        The [ATTACK] and [DECAY] potentiometers control attack and decay times,
        and the [AMOUNT] potentiometer controls the envelope amount. Like the
        filter, it is bipolar, you can have negative or positive envelopes. By
        default, the X-Envelope is applied to the parameter, but it can be
        routed to the X-Modulator amount : hold [FUNC], and press [TYPE] +
        [WAVE]. A blinking X-Env amount pot indicates that the X-Envelope is
        routed to X-Mod amount.
      </p>
      <h3 id="modulation-modulator" manual-section-trigger="true">
        X-Modulator
      </h3>
      <p>
        The X-Modulators are simple oscillators, I didn't call them LFO because
        one of their best use cases is in audio rate mode.
      </p>
      <p>
        The [WAVE] key cycles between sinusoidal, triangle, square sawtooth, and
        S&H waveforms.
      </p>
      <p>
        The [TYPE] key lets you select one of the 3 types : LFO (LED off),
        synced LFO (LED blinking), and Audio Rate (LED on). LFO mode gives you
        rates between 40 seconds and 100ms, synced LFO has 12 different sync
        values, and resets at the beginning of the pattern. At audio-rate you
        get a tuned modulator ranging from C0 to C8. In audio rate, the
        X-modulators follow oscillator 1 frequency.
      </p>
      <h3 id="modulation-example" manual-section-trigger="true">
        A few examples
      </h3>
      <h4 id="modulation-kick" manual-section-trigger="true">
        Kick drum
      </h4>
      <img
        className="manual-img"
        style={{ width: "300px", display: "block", float: "right" }}
        src={schemaPatch1}
        alt="kick"
      />
      <p>A kick drum starts with a simple tone with a pitch envelope.</p>
      <ul>
        <li>Open the filter</li>
        <li>turn up oscillator one</li>
        <li>Set oscillator 1 wave to sinus</li>
        <li>Set a low frequency to oscillator 1</li>
        <li>Select Oscillator 1</li>
        <li>Set X-Env Attack to minimum</li>
        <li>Set X-Env Decay center</li>
        <li>Slowly turn X-Env amount clockwise while triggering Mono</li>
        <li>Et voilà, the beginning of your own amazing kick</li>
      </ul>
      <h4 id="modulation-phase" manual-section-trigger="true">
        Evolving phase effect
      </h4>
      <img
        className="manual-img"
        style={{ width: "300px", display: "block", float: "right" }}
        src={schemaPatch2}
        alt="phase"
      />
      <p>
        When 2 oscillator's frequencies are very close, it leads to interesting
        phase effects. If you modulate that frequency with an LFO, the effect
        will evolve in time, leading to even nicer subtle changes.
      </p>
      <ul>
        <li>Open the filter</li>
        <li>Turn up both oscillator</li>
        <li>Set both oscillator frequency to the same pitch</li>
        <li>Select oscillator 1 detune</li>
        <li>Set X-Mod to LFO or Synced LFO</li>
        <li>Set X-Mod Rate as you see fit</li>
        <li>Slowly turn X-Mod amount, either way</li>
        <li>Let the magic happen</li>
      </ul>

      <h4 id="modulation-pinged" manual-section-trigger="true">
        Pinged FM sound
      </h4>
      <img
        className="manual-img"
        style={{ width: "300px", display: "block", float: "right" }}
        src={schemaPatch3}
        alt="pinged"
      />
      <p>
        Most string instruments have a rich harmonic content at the beginning,
        and then slowly fade to a more muffled sound. In East-Coast synthesis
        this is usually imitated with an enveloped low-pass filter. West-Coast
        approach usually involve FM instead, here is one way to do it :
      </p>
      <ul>
        <li>Open the filter</li>
        <li>Turn up oscillator 2</li>
        <li>Set oscillator 2 to sinus wave</li>
        <li>Set oscillator 1 and 2 frequency 1 octave apart (or not)</li>
        <li>Select FM parameter</li>
        <li>Set X-Env Attack to minimum</li>
        <li>Set X-Env Decay center</li>
        <li>Slowly turn X-Env amount clockwise while triggering Mono</li>
        <li>The more you open it, the bigger the effect</li>
      </ul>

      <h4 id="modulation-filter" manual-section-trigger="true">
        Filter FM
      </h4>
      <img
        className="manual-img"
        style={{ width: "300px", display: "block", float: "right" }}
        src={schemaPatch4}
        alt="filter"
      />
      <p>
        Mono's filter responds really well to frequency modulation, it's a cool
        option to add harmonic content to any patch.
      </p>
      <ul>
        <li>Start with any patch you want</li>
        <li>Select filter cutoff parameter</li>
        <li>Set X-Mod to audio-rate</li>
        <li>Set X-Mod rate dead center (frequency will be the same as osc1)</li>
        <li>Turn X-Mod amount left or right to add FM</li>
        <li>Changing X-Mod wave gives a different FM “flavour”</li>
      </ul>
      <h2 id="sequencer" manual-section-trigger="true">
        Sequencer
      </h2>
      <h3 id="sequencer-intro" manual-section-trigger="true">
        Intro
      </h3>
      <p>
        Mono's sequencer does everything you'd expect from an integrated
        sequencer, and more. I tried to implement everything that made sense,
        without cluttering the interface too much. The sequencer was designed to
        give musicians a way to fully customize sequences by recording
        automation on any desired parameter. The powerful clocking system makes
        Mono extremely versatile, whether you are in the studio, in a live
        situation or even in DJ sets. Mod Note mode replaces notes by user
        defined timbre.
      </p>
      <h3 id="sequencer-projects-and-basic" manual-section-trigger="true">
        Projects and basic pattern operation
      </h3>
      <h4
        id="sequencer-projects-and-basic-projects"
        manual-section-trigger="true"
      >
        Projects
      </h4>
      <p>
        Mono holds 32 projects in memory. Projects need to be saved to be
        persisted in memory, save by holding [FUNC] and hitting [SAVE]. To load
        a project, hold [FUNC] and hit [LOAD], you will see four red LED blink (UP, DOWN, ACCENT, SLIDE).
        Projects are organized into pages of 16, use the [PAGE] key to select a page (projects 1 to 16 are on page
        A, projects 17 to 32 on page B), then hit a [SEQ] key to load the
        desired project. Don't forget to save the current project before loading
        another one ! Saving and loading is very fast (less than a second) and
        doesn't break tempo, you can safely load and save in the middle of a
        live show.
      </p>
      <ul>
        <li>Projects can be changed while the sequencer is running</li>
        <li>
        While in project load mode, hold [FUNC] + [PASTE], then press once a [SEQ]
        key to select the desired slot to paste the current project. The selected [SEQ] LED
        is blinking, then press again the [SEQ] key to confirm the project paste.
        This procedure is to ensure that you don't paste a project by mistake, it will
        overwrite the project in the selected slot.
        </li>
      </ul>
      <h4
        id="sequencer-projects-and-basic-patterns"
        manual-section-trigger="true"
      >
        Patterns
      </h4>
      <p>
        The 64 patterns of a project are organized into 4 pages. Hit the
        [PATTERN] key to open pattern mode. Patch load on pattern shift is deffered 
        to the first trig of newly loaded pattern. Therefore long note aren’t silenced 
        at the end of the ending pattern anymore. In pattern mode, the bright key
        indicates a slot with a pattern, the dimmed key indicates a slot with a
        patch but no pattern, the current pattern [KEY] blinks, and the next
        pattern's [KEY] pulses. To switch pattern, select a [PAGE] and hit a
        [SEQ] key to set the current pattern. For example, press C, then 5 to
        select the C05 pattern. To play a pattern temporarily, hold [FUNC] and
        press the pattern [SEQ] key, when releasing [FUNC] the previous pattern
        will resume playing. Press [PATTERN] again to quit pattern selection
        mode. 
      </p>
      <ul>
        <li>Patterns can be changed while the sequencer is running.</li>
        <li>Patterns can be changed with program changes messages.</li>
        <li>
          While in pattern selection mode, hold [FUNC] + [COPY] and hit a [SEQ]
          key to copy the desired pattern, then hold [FUNC] + [PASTE] and hit
          the destination [SEQ] key.
        </li>
        <li>
          Hold [DELETE], and hit a [SEQ] key to clear the desired pattern. Note
          that undoing a Pattern Clear can only be done once, if you clear a
          pattern, make a new one, and clear that, you won't be able to recall
          the first cleared pattern. Note that [DELETE] + [PATTERN] won't clear the patch.
        </li>
      </ul>
      <h4
        id="sequencer-projects-and-basic-pattern-control"
        manual-section-trigger="true"
      >
        Pattern control
      </h4>
      <p>
        Press [RUN] to start the playback of a pattern, press [RUN] again to
        stop and reset. The [SEQ] keys LEDs indicate the playback position. If a
        pattern contains more than 16 steps, the [PAGE] keys LED indicate the
        position. The currently selected page is indicated by a dimmed LED.
      </p>
      <h4
        id="sequencer-projects-and-basic-pattern-length"
        manual-section-trigger="true"
      >
        Pattern Length
      </h4>
      <p>
        Hold [FUNC] and hit [LENGTH] to open the pattern length setting. You are
        now familiar with the next step : select “page” length with a [PAGE]
        key, then the actual length with a [SEQ] key. For example, for a 50 step
        pattern, press [PAGE] D and [SEQ] 2 (3x16+2), should be doable even
        after a few beers. Hit [FUNC] to leave setting mode.
      </p>
      <h4 id="sequencer-projects-and-basic-tempo" manual-section-trigger="true">
        Tempo
      </h4>

      <p>
        When clocked internally, there are several ways to change the current
        tempo.
      </p>
      <ul>
        <li>
          Hold [TEMPO] and press [UP] or [DOWN] to increment or decrement the
          tempo by 1.
        </li>
        <li>
          Hold [TEMPO] and enter a number with the 0 to 9 [SEQ] key. For
          example, for 135 BPM, hold [TEMPO] press [SEQ] 1, then 3, then 5, and
          release [TEMPO].
        </li>
        <li>
          Tap the [TEMPO] key in a steady rhythm at least 4 times to set a tempo
          manually. After four consecutive taps, the average tempo of the taps
          will be calculated. By continuing tapping, the average tempo will keep
          on updating.
        </li>
        <li>
          Hold [TEMPO] and rotate the X-MOD [AMOUNT] potentiometer to speed
          up/slow down tempo by +/-16%, the pot center being 0. Similar to a
          turntable pitch fader.
        </li>
      </ul>
      <h4
        id="sequencer-projects-and-basic-play-styles"
        manual-section-trigger="true"
      >
        Play styles
      </h4>
      <p>
        Play styles allow you to alter the order in which the sequencer plays the
        steps of a pattern. The default of course is forward. When you switch to
        a non default play style, going back to the forward mode will position
        the play head to where it should be e.g it won't ruin your sync.
      </p>
      <p>
        <Row className="row-settings">
          <Col className="settings-col">
            <span className="param-enum">1</span> Forward (Default)
            <br />
            <span className="param-enum">2</span> Reverse
            <br />
            <span className="param-enum">3</span> Synced Pendulum
            <br />
            <span className="param-enum">4</span> Pendulum
            <br />
            <span className="param-enum">5</span> Drunk (2 Forward, 1 backward)
            <br />
            <span className="param-enum">6</span> Reverse drunk
            <br />
            <span className="param-enum">7</span> Random Drunk (75% chance
            forward, 25% backward)
            <br />
            <span className="param-enum">8</span> Reverse Random Drunk
            <br />
            <span className="param-enum">9</span> Random
            <br />
          </Col>
        </Row>
      </p>
      <p>
        You can change play style by going to the Play mode menu, [FUNC] + [RUN],
        and select one of the 9 play modes with the [SEQ] keys 1 to 9.
      </p>
      <h4
        id="sequencer-projects-and-basic-play-modes"
        manual-section-trigger="true"
      >
        Play modes
      </h4>

      <p>
        You can change the behaviour of the sequencer when a pattern switch
        occurs with the play mode setting. There are 3 play modes, if you are
        familiar with Elektron gear, they are equivalent (no need to reinvent
        what's already great right ?).
      </p>
      <ul>
        <li>
          A. Sequential (default) : The pattern switch occurs at the end of the
          currently playing pattern
        </li>
        <li>
          B. Direct Jump : The pattern switch occurs immediately, the new
          pattern will start from the position where the previous pattern left
          off.
        </li>
        <li>
          C. Direct Start : The pattern switch occurs immediately, the new
          pattern will start playing from the beginning.
        </li>
      </ul>
      <p>
        You can change play mode by going to Play mode menu, [FUNC] + [RUN], and
        select one of the 3 play modes with the [PAGE] A, B or C keys.
      </p>
      <h4
        id="sequencer-projects-and-basic-live-mode"
        manual-section-trigger="true"
      >
        Live mode
      </h4>
      <p>
        Live mode allows musician to heavily edit the running pattern without
        affecting it in memory. When live mode is enabled, a snapshot of the
        active pattern is taken when it starts. You can edit everything (patch,
        pattern, automations ...), but when you switch to another pattern or
        recall the same pattern, it will revert back to its saved state. Live
        mode also affect Mod Notes : when a Mod Note is selected on the mini
        keyboard, you can edit it, but when you leave Live Mode, it'll revert 
        back to the saved state. Toggle live mod by holding [PATTERN] + [RUN] 
        and hit the [RECORD] key. [RECORD] blinks when live mode is enabled.
      </p>
      <p>
        If you do want to save the changes you've made to the pattern while live
        mode is enabled, you need to save the project. Note that disabling live
        mode will also revert the pattern back to the saved state, so don't
        forget to save if you want to retain your changes.
      </p>
      <h4
        id="sequencer-projects-and-basic-loop-mode"
        manual-section-trigger="true"
      >
        Loop mode
      </h4>
      <p>
        Loop mode is a live oriented feature that allows you to play a small
        part of a pattern temporarily. It is especially useful in live
        situations to create movement on-the-fly. To enable it, hold [FUNC] and
        select your start point byt hitting a [SEQ] key, then the end point with
        another [SEQ] key. You can also set a reversed loop selecting the ending 
        step before the starting step. The loop will start at the next step after 
        releasing the [FUNC] key. To leave the loop, hit [FUNC] again. The full pattern
        will resume playback as if it was running in the background. Loop mode
        only works on a single page, selecting a start point located after the
        end point plays the loop backward.
      </p>
      <h4
        id="sequencer-projects-and-basic-song-mode"
        manual-section-trigger="true"
      >
        Song mode
      </h4>
      <p>
       The number of chained pattern to create a song is unlimited. When a song
        is playing, it will play the selected pattern sequentially, and loop
        back to the first one at the end. To create a song, you need to be in
        pattern mode, press [PATTERN], the LED should be on. Once in pattern
        mode, hold [PATTERN] and hit the [SEQ] key of the pattern you want to
        add to your song in the correct order (you can add the same pattern
        several times). Once you release [PATTERN], your song will start
        playing. To leave song mode, press a [SEQ] key.
      </p>
      <h4
        id="sequencer-projects-and-basic-patchless-pattern"
        manual-section-trigger="true"
      >
        Patchless pattern
      </h4>
      <p>
        When playing a song with normal patterns, the patch of the patterns will
        be called at each jump, so if you have the same patch on several
        patterns, it will be recalled as it was on each jump. If you are
        modulating a parameter live, this is not the behaviour you expect from
        the synth.
      </p>
      <p>
        To remedy this issue, you can set a pattern in “patchless mode”. A
        patchless pattern won't call it's associated patch when it starts, it
        will keep the previous pattern patch. This way you can create a song
        with the same patch by setting each pattern in patchless mode (not the
        first one obviously).
      </p>
      <p>
        To set a pattern in patchless mode, hold [PATTERN] and hit [RECORD], the
        blinking [PATTERN] LED indicates that the current pattern is patchless.
        Hold [PATTERN] and press [RECORD] to disable patchless mode.
      </p>

      <h4 id="sequencer-pattern-morphing" manual-section-trigger="true">
        Pattern morphing
      </h4>
      <p>
        When activated, it allows you to morph between two patterns and explore the 
        “in between” patterns. What does it do ? Every synth parameter of a current
        pattern will shift to the selected pattern parameters. When in pattern mode, 
        hold [FUNC] + [PATTERN] and press a desired pattern you want to morph with. 
        The selected pattern should blink. Then hold [FUNC] and turn the [CUTOFF] pot clockwise
        to morph between the main and the morphing pattern.
      </p>

      <h4 id="sequencer-duonote-mode" manual-section-trigger="true">
        Duophonic note mode
      </h4>
      <p>
        In this mode you can set a different pitch to each oscillator.
        Press [FUNC] + [SWING] and select [B] to enable the mode.
        Hold or press two [NOTE] on the mini keyboard to set the duophonic 
        pitch and press a [SEQ] to put the duonote trig on the sequence. 
        You can also edit the second pitch of a duonote by holding [FUNC] + 
        [SEQ] position, and selecting a pitch on the mini keyboard 
        (allows for spreads wider than an octave). The first [NOTE] pressed will 
        trigger the first oscillator and the second [NOTE] pressed will trigger the second one.
      </p>

      <h3 id="sequencer-editing" manual-section-trigger="true">
        Editing a pattern
      </h3>

      <p>
        There are two ways of adding notes and automations with Mono : either by
        inputting it manually, or by recording it live while the sequencer is
        running in record mode. Each step contains information that dictates the
        behaviour of the synthesis engine at said step. A step can trigger a
        note with a note trig, but can also contain only parameter offsets which
        alters the timbre.
      </p>
      <h4 id="sequencer-editing-mini-keyboard" manual-section-trigger="true">
        Mini keyboard
      </h4>
      <p>
        The [NOTE] keys act like a one octave keyboard (without velocity of
        course). You can play a note to preview your current patch, use it in
        record mode, and select the currently active note. When booting up, the
        active note is C4, the selected note is indicated by a bright [NOTE] key
        LED. Press a [NOTE] key to change the currently selected note. Use the
        [UP] and [DOWN] key to change the current octave. There are 9 octaves
        available, from C0 to C10.
      </p>
      <p>
        When you hold a [NOTE] key, the [SEQ] key containing that note will
        pulse.
      </p>
      <h4 id="sequencer-editing-adding-note" manual-section-trigger="true">
        Adding notes manually
      </h4>
      <p>
        Adding note trigs manually on Mono is quite simple : just hit the
        desired [SEQ] key, it adds a note trig on that step with the currently
        selected [NOTE]. An active step is indicated by a bright LED. Select the
        page where you want to add a note with the [PAGE] key. To remove a note
        trig, hit a step with an active note trig, the led will turn off.
      </p>
      <h4 id="sequencer-editing-recording-notes" manual-section-trigger="true">
        Recording notes
      </h4>
      <p>
        You can record incoming notes live using the [NOTE] keys or an external
        keyboard. Enable recording by pressing the [RECORD] key. The [RECORD]
        key LED indicates wether the record mode is enabled or not. Recording a
        note on top of an already active note trig overwrites it. The recorded
        notes are quantized to the closest step by default but can be disabled.
        Press [FUNC] + [Bend Rg], select [PAGE A] to disable quantization and [PAGE B] to enable it.
        
      </p>
      <h4 id="sequencer-editing-sh-style" manual-section-trigger="true">
        SH-style sequencing
      </h4>
      <p>
        When the pattern is not playing and [RECORD] is enabled, a step [SEQ]
        key LED pulses, indicating the active step. Playing a note with the
        [NOTE] key adds a note to the active step and advances by one step. Keep
        playing notes to fill the pattern. You can place the "record head"
        anywhere by pressing the associated [SEQ] key.
      </p>
      <h4 id="sequencer-editing-change-pitch" manual-section-trigger="true">
        Change the pitch of a note
      </h4>
      <p>
        Hold the [SEQ] key of an active step and hit the desired [NOTE] key. You
        can also change the the pitch by semitone by holding the [SEQ] key and hitting 
        [UP] or [DOWN].
      </p>
      <h4 id="sequencer-editing-note-length" manual-section-trigger="true">
        Note length
      </h4>
      <p>
        Single step note trigs, and very short recorded notes have a particular
        behaviour on Mono. Classic ADSR envelope will not do much with a short
        pulse - if the attack is longer than a few ms, you won't hear anything …
        Fortunately Mono's envelopes are digital ! Basically, when the sequencer
        hits a single step note trig, the envelope will act as an AD envelope,
        ignoring sustain and release values. It was actually implemented by
        mistake, but I found it amazing so I kept it.
      </p>
      <p>
        Anyway, to edit a note length, hold the [SEQ] key of the desired step,
        and hit the [SEQ] key where you want the note to end. The length will be
        visible with dimmed [SEQ] LEDs.
      </p>
      <h3 id="sequencer-step" manual-section-trigger="true">
        Step parameters
      </h3>
      <h4 id="sequencer-step-accent" manual-section-trigger="true">
        Accent
      </h4>
      <p>
        Accent can be added on a per step basis. Hit [ACCENT] to open accent
        mode, and hit the desired [SEQ] key to add or remove accents from steps.
        In accent mode, the active note trigs are shown by a dim [SEQ] key LED,
        active accents are shown by a bright [SEQ] key LED. Hit [ACCENT] again
        to leave accent mode. The same can be done when just holding the
        [ACCENT] key.
      </p>
      <h4 id="sequencer-step-accent-param" manual-section-trigger="true">
        Accent parameters
      </h4>
      <p>
      By default an accent slightly increases the amp level and the filter cut-off frequency, 
      but this is entirely customisable. To set your own accent parameters on the active pattern, 
      start by setting default offsets to 0 by holdind [ACCENT] and set Cutoff and Volume to the middle. 
      Keep holding accent and set pots to the desired value. The value stored in memory is an offset 
      from the initial value to the last position of the potentiometer. For example, if the cutoff 
      value is set dead center and you move it 20% to the right while holding [ACCENT], every accented 
      step will have a higher cut-off frequency by this amount, whatever the current value is, 
      or if there is automation on that step. You can add as many values as you want, 
      by it synth parameters or modulation parameters.
      </p>
      <h4 id="sequencer-step-accent-ratio" manual-section-trigger="true">
        Global Accent ratio
      </h4>
      <p>
        The global accent ratio is a useful live feature. When holding [UP] +
        [ACCENT], the X-Mod amount potentiometer allows to set the ratio of the
        accent applied to the accented note. At full right, 100% of the accent is
        applied (default behaviour), at noon, 0% is applied, and at full left
        -100% of the accent is applied, creating a "negative accent". The global
        accent ratio is reset to zero when switching patterns.
      </p>
      <h4 id="sequencer-step-slide" manual-section-trigger="true">
        Slide
      </h4>
      <p>
        Slide can be added on a per step basis. Hit [SLIDE] to open slide mode,
        and hit the desired [SEQ] key to add or remove slide to a step. When a
        slide is active on a step, all the step parameters will slide linearly
        to the next step parameters (note as well as parameter offsets). In
        slide mode, the active note trigs are shown by a dim [SEQ] key LED.
        Active slide trigs are shown by a bright [SEQ] key LED. Hit [SLIDE]
        again to leave slide mode. The same can be done when just holding the
        [SLIDE] key. To clear all slides, hold [SLIDE] and hit [DELETE].
      </p>
      <h4 id="sequencer-step-slide-rate" manual-section-trigger="true">
        Slide Rate
      </h4>
      <p>
        The rate of the slide, or in other word, the time it gets to the slide to 
        get to the target note, can be set on a per pattern basis. Hold [Slide] and [Record] and
        turn the [XModRate] potentiometer to set the slide rate. The slide default 
        position (at noon on the pot), is a length of half a step.

      </p>
      <h4 id="sequencer-step-param" manual-section-trigger="true">
        Microshift, probability, ratchet
      </h4>
      <p>
        Each step of a pattern contains a microshift, probability, and ratchet
        value. These 3 parameters together allow musicians to create very
        organic sequences - it's an excellent way to break the 4/4 monotony that
        usually haunts an x0x-style sequencer. To edit one of these parameters,
        hold [FUNC] + the desired [SEQ] key, and set the value with
        [MICROSHIFT], [PROBABILITY] or [RATCHET] potentiometer.
      </p>
      <p>
        You can record microshift, probability, and Ratchet automation when
        [RECORD] is enabled, by holding [FUNC] and moving the associated knob.
      </p>
      <p>
        Hold [DELETE] + [FUNC] (in that order), and move the associated knob to
        delete all microshift/probability/ratchet of the current pattern.
      </p>
      <ul>
        <li>
          Microshift : The microshift parameter shifts the starting point of a
          step forward or backward by up to ½ step.
        </li>
        <li>
          Ratchet : The ratchet parameter multiplies the number of note trigs in
          a single step. From 1 (default behaviour) when the pot is fully
          counterclockwise to 16 fully clockwise. The trigs are evenly
          distributed on the time between the start of the selected step and the
          start of the next step, even when both have different microshift
          values.
        </li>
        <li>
          Probability : The probability as its name suggests gives note trigs a
          certain probability to be sent to the synth engine or not. From 100%
          probability hard left, to 0% hard right. When combined with the
          ratchet value, each ratcheted note trigs are subjected to the
          probability parameter.
        </li>
      </ul>
      <h4 id="sequencer-step-mutes" manual-section-trigger="true">
        Step Mutes
      </h4>
      <p>
        To create interesting variations on the fly, it is possible to Mute
        individual steps of a pattern. To do so, hold [DOWN] and hit the step's
        [SEQ] key you want to mute/unmute. All the selected steps will be
        muted/unmuted upon releasing the [DOWN] key. The muted steps are
        indicated by a blinking [SEQ] key. Off course you can mute steps that
        only contain offset informations.
      </p>
      <p>
        To unmute all steps (and mod notes : see mod note mutes) all at once,
        hold [DOWN] and press [DELETE].
      </p>
      <h3 id="sequencer-param-offset" manual-section-trigger="true">
        Parameter offsets or automations
      </h3>
      <p>
        Mono's automations work a bit differently from most of the other
        hardware synthesizers I know of. They are not “step-locked” with a fixed
        value but rather an offset value from the actual position of the
        potentiometer. When adding a parameter offset to a step, each time said
        step is triggered by the sequencer the parameter will be “offseted” from
        the potentiometer position by the amount of the parameter offset value.
      </p>
      <p>
        Say a parameter value ranges between 0 and 100, and the potentiometer of
        this parameter is set dead center. At this setting, the current value,
        or potentiometer value is 50. If you add an offset value to a step by
        holding a [SEQ] key and turning said potentiometer a bit to the right,
        say to 60. Then you are adding a parameter offset of 10 to that step.
        Now each time the sequencer plays that step, it will add an offset of 10
        to said parameter, and go back to the current value, or to the actual
        potentiometer value at the next step.
      </p>
      <p>
        Each step can hold up to 48 parameter offsets - it is possible to add
        offsets to every parameter, either synth parameters (filter cut-off,
        oscillator waves, enveloppe decay…) or modulation parameters (filter
        resonance X-MOD Rate, oscillator frequency X-ENV amount …).
      </p>
      <p>
        This feature really turns the Mono sequencer into a powerhouse,
        everything can be sequenced, and sequencing parameters doesn't “fix” the
        parameters value, but it adds a sequence “on top” of the current
        potentiometer position. This approach gives the user the freedom to
        adjust the knobs while performing in a live situation.
      </p>

      <h4 id="sequencer-param-offset-visual" manual-section-trigger="true">
        Parameter offset visualization
      </h4>
      <p>
        On V2.0 you can visualize parameter offsets immediately on potentiometer LEDs.
        LEDs intensity will show you how the offset strength is.
      </p>
     
      <h4 id="sequencer-param-offset-add" manual-section-trigger="true">
        Adding parameter offsets
      </h4>
      <p>
        To add a parameter offset on a step, hold a [SEQ] key, and turn the
        desired knob either way to add an offset - the more you turn the knob,
        the bigger the offset. The same can be done to modulation parameters -
        don't forget to select the synth parameter on which you want to add the
        modulation parameter offset first (that's a lot of words - sorry about
        that). You can add offsets to Sync, Follow, and X-Mod Type and Wave as
        well.
      </p>

      <h4 id="sequencer-param-offset-record" manual-section-trigger="true">
        Recording parameter offsets
      </h4>
      <p>
        You can also record parameter offsets while in record mode. To enable
        the mode, press the [RECORD] key, and turn a parameter knob while the
        sequencer is playing. This will add a parameter offset on each step
        where a parameter knob position change is detected, so you need to
        continually move the knob to add offsets at every step. This is a bit
        strange at first but it was mandatory, otherwise everything would be
        recorded at 0 offset as soon as [RECORD] is enabled, that's obviously
        not the best behaviour …
      </p>
      <h4 id="sequencer-expressive-param-offset" manual-section-trigger="true">
         Custom expressive parameter offsets
      </h4>
       <p>
         V2.0 allows you to set velocity, pitchbend, aftertouch, vertical. Each of these MIDI parameters 
         can affect the patch according to custom offsets on any and all parameters and their modulation values, 
         just like the accent on V1. To check nor set these offset, a switch needs to be held, when the switch 
         is held the LED brightness of the parameter shows the offset “strength”. Offset can be negative, 
         a potentiometer at center position means no offset, full CCW means maximum negative offset, 
         full CW means maximum positive offset.
       </p>
       <p>Here are the 4 switches :</p>
       <p> 
        <ul> 
          <li>
          [SLIDE] - Velocity
          </li>
          <li>
          [UP] - Aftertouch
          </li>
          <li>
          [DOWN] - Vertical (CC74)
          </li>
          <li>
          [FOLLOW] - Pitch (pitchbend)
          </li>
        </ul>
       </p>
       <p>
         These MIDI parameters can be recorded on each steps, like automation when played from an external keyboard 
         or sequencer. There are also ways to edit velocity and Vertical (CC74) automation directly on the synth, as follow.
       </p>

       <h4 id="velocity" manual-section-trigger="true">
         Velocity
      </h4>
       <p>
         To edit a step velocity, hold [FUNC] + the [SEQ] step, and use the X-Mod
         amount pot to set the velocity from 0 at full CCW to 127 at full CW. When record is
         enabled, you can hold [FUNC] and move the X-Mod amount pot to record velocity
         values on the fly.
       </p>

       <h4 id="vertical" manual-section-trigger="true">
         Vertical
      </h4>
       <p>
         Vertical or  CC74 is often used for the vertical (Y) axis on expressive keyboard.
         To edit the CC74 of a step (regardless if there is a trig on that note or not), hold
         [FUNC] + the [SEQ] step, and use the X-Mod Rate pot to set the CC74 value, from 0
         at full CCW to 127 at full CW. When record is enabled, you can hold [FUNC] and
         move the X-Mod amount pot to record CC74 values on the fly.
       </p>


      <h4 id="pitchbend" manual-section-trigger="true">
         Pitchbend
      </h4>
       <p>
         A pitch offset makes the parameter follow the pitch played on the synth (note + pitchbend). 
         By default the 2 oscillators and the filter have an offset of 1 semitone by semitone. 
         The filter tracking can still be enabled/disabled with the follow switch. 
         On the two oscillators on the filter the offset is not linear but quantized, 
         this allow for microtonal/macrotonal playing. At center position the oscs/filter don’t track, 
         there are then 6 positions on the positive and negative side : ⅛ semitone - ¼ semitone - ½ semitone 
         - 1 semitone - 1 tone - 2 tone.
       </p>

       <h4 id="aftertouch" manual-section-trigger="true">
         Aftertouch
      </h4>
       <p>
         Aftertouch is the only parameter that cannot be set directly on Mono, but can be recorded via MIDI. 
         Press [DELETE] + [UP] to clear aftertouch automations.
       </p>
      <p>

      </p>
      <p>
        Note that when recording automation on the [FREQ] parameter, the
        recorded parameter offsets will be quantized to the current scale.
      </p>
      <h3 id="sequencer-unlink-env" manual-section-trigger="true">
        Unlink X-Env Sequence
      </h3>
      <p>
        To create interesting effects in a pattern, it is possible to unlink the
        X-Envelope triggers from the note trigs. When doing so, the X-Envelope
        of the selected parameter will be replaced by the one entered on the
        [SEQ] keys.
      </p>
      <p>
        To create an unlinked X-Env sequence, start by selecting the desired
        parameter - [CUTOFF] for example. Then hold [TYPE] + [WAVE], and hit
        [SEQ] keys to create your unlinked sequence. As you see the bright [KEY]
        show the unlinked sequence. To disable an unlinked sequence and trig the
        X-Env with the note trigs again, you need to disable all the unlinked
        trigs.
      </p>
      <p>Unlinked X-Env trigs will also reset the LFO phase !</p>
      <h3 id="sequencer-copy" manual-section-trigger="true">
        Copy paste and clear
      </h3>
      <p>
        To copy a step, hold [FUNC] + [COPY] then hit the [SEQ] key of the step
        to be copied. To paste, hold [FUNC] + [PASTE], and hit the destination
        [SEQ] key. You can also copy a range of steps, hold [FUNC] + [COPY], hold 
        the start [SEQ] of the range and press the end [SEQ]. Then hold [FUNC] + 
        [PASTE], the starting [SEQ] step where you want to paste, and then the end [SEQ].
        Clear a step by holding [DELETE] and hitting the desired [SEQ] key. These step
         operations act on every parameter - note, accent, slide, parameter offset and so on.
      </p>
      <p>
        The same can be done with full pages, use the desired [PAGE] key
        instead. You can now copy a page and paste it on an other page 
        without having to set the pattern length. Hold [FUNC] + [COPY] 
        and press the [PAGE] to copy, then hold [FUNC] + [PASTE] and press 
        the [PAGE] where you want to paste.
      </p>
      <p>
        To copy a whole parameter automation (all parameter offsets on the
        pattern), hold [FUNC] + [COPY] and slightly move the potentiometer of
        the desired parameter. To paste, hold [FUNC] + [PASTE] and slightly move
        the target parameter. To clear a whole parameter hold [DELETE] and
        slightly move the desired potentiometer.
      </p>
      <p>
        You can also copy, paste and clear a patch. To do so, use the [RECORD]
        button : To copy, hold [FUNC] + [COPY] and press [RECORD]. Navigate to
        the pattern where you want to paste the patch, hold [FUNC] + [PASTE] and
        hit [RECORD]. To delete a patch, hold [DELETE] and press [RECORD]. The
        patch will be cleared to the default patch.
      </p>
      <h3 id="sequencer-undo" manual-section-trigger="true">
        Undo/Redo operations
      </h3>
      <p>
        Every single action of the sequencer is undoable. If you are not quite
        happy with a recorded automation, you can undo it. Hate that change of
        pitch on the last 4 notes ? Undo it. Not so bad in the end ? Redo it.
        Simple hold [FUNC] and hit [UNDO] to undo and … you guessed it, hold
        [FUNC] and hit [REDO] to redo.
      </p>
      <h3 id="sequencer-settings" manual-section-trigger="true">
        Pattern settings
      </h3>
      <h4 id="sequencer-settings-scale" manual-section-trigger="true">
        Scale and root note
      </h4>
      <p>
        To set up a scale and a key, hold [FUNC] and hit [SCALE]. Set up the
        root note with the [NOTE] key and set the scale with the [SEQ] key. Here
        is the list of the scale and their related [SEQ] key. Scale and root are
        mostly useful with the randomizer, more on the next section. You can
        visualize the selected scale on the mini keyboard. Only the [NOTE] key
        LED in the selected scale are on, with the root note a bit brighter. If
        you are allergic to music theory, this is a pretty handy tool.
      </p>
      <h4 id="sequencer-settings-custom-scale" manual-section-trigger="true">
        Custom scales
      </h4>
      <p>
        Each project hold 4 custom scales on top of the 16 fixed scales. You can
        select it with the [PAGE] keys while the scale setting is active. To
        add/remove note from a custom scale, hold the desired [PAGE] key and hit
        [NOTE] keys on the MIDI keyboard.
      </p>
      <h4 id="Scale-autoquantize" manual-section-trigger="true">
         Scale autoquantize
      </h4>
       <p>
         When scale autoquantize is enabled, changing the scale
         will move the notes of the pattern according to the new scale, it uses a smart
         algorithm that works pretty well even on custom scale. The algorithm is however
         destructive : if you go from a 7 note scale to a custom scale of 4 notes and switch
         back to a 7 note scale, you wont get back the same pattern.
       </p>
      <h4 id="sequencer-settings-transpose" manual-section-trigger="true">
        Transpose
      </h4>
      <p>
        To transpose a whole pattern hold [FUNC] and hit [TRANSPOSE], you can
        select the transposition level with the [NOTE] keys. Use the [SEQ] key
        to select the octave. Key 8 is the default value.
      </p>
      <h4 id="sequencer-settings-beat-div" manual-section-trigger="true">
        Beat division
      </h4>
      <p>
        To set up the pattern beat division, hold [FUNC] and hit [BEAT DIV]. The
        selected [SEQ] key defines how many steps are played each beat, default
        is 4.
      </p>
      <h4 id="sequencer-settings-swing" manual-section-trigger="true">
        Swing
      </h4>
      <p>
        To set up the swing value of the current pattern, hold [FUNC] and hit
        [SWING]. The default value is 9 (no swing). A smaller value will add
        shuffle to the pattern (advance odd step), and a greater value will add
        swing (delay odd step).
      </p>
      <h3 id="sequencer-mod-note" manual-section-trigger="true">
        Mod Note mode
      </h3>

      <p>
        The mod note mode is a little bonus mode that allows users to create up
        to 40 custom temporary patch or timbre settings per project to be played
        and recorded. Hit [UP] + [DOWN], both keys LED should be on indicating
        that you enabled Mod Note mode. The 8 bottom [NOTE] keys each represent
        a timbre, you can't use them to play pitch anymore.
      </p>
      <p>
        The mod notes are scoped to the project, each project can hold 40 mod
        notes, separated into 5 pages. You can scroll the pages with the [UP]
        and [DOWN] key.
      </p>
      <p>
        To set up the timbre, select one of those Mod Note keys, say the D
        [NOTE] key. When you select an empty Mod Note slot, the current patch
        will be copied to that mod note slot. Editing the timbre by rotating
        knobs will now edit that Mod Note's timbre. Every time you play that
        key, the timbre that you recorded will be played. It is not recorded as
        offsets, and therefore not limited to the 48 parameters limit. It will
        virtually turn the potentiometer to the recorded positions. You can add
        note trigs just as you would do in normal mode to create a sequence of
        Mod Notes.
      </p>
      <p>
        The next "normal" note trig played by the sequencer after a mod note
        will revert the synth parameters back to the pattern's patch values. So
        you can use these Mod Notes to create “happy accidents” in an otherwise
        simple pattern by playing it live for example, or to create weird
        patterns using different timbres. Go back to normal mode by pressing
        [UP] + [DOWN] again.
      </p>
      <p>
        Note that you can't edit the pattern's patch once in Mod Note, for that
        you will need to go back to "normal" player mode. You can check weither
        or not a particular Mod Note is present in your current Pattern by
        holding that Mod Notes [KEY]. The [SEQ] key containing it will pulse.
      </p>
      <h4 id="sequencer-mod-note-pitch" manual-section-trigger="true">
         Mod Note pitch
      </h4>
       <p>
         You can edit a Mod Note note pitch : hold the mod note [KEY] and press 
         [UP] or [DOWN] to set the mod note octave. Hold [UP] + [DOWN] and press a [KEY] 
         to set the current modnote semitone. Hold a step [SEQ] that contains a modnote and 
         press [UP] or [DOWN] to change its pitch.
       </p>
      <h4 id="sequencer-mod-note-autom" manual-section-trigger="true">
         Automation on Mod Note
      </h4>
       <p>
         Mod Note notes are not “set in stone” as they used to be, they 
         can now be affected by automations.
       </p>
      <h4 id="sequencer-mod-note-mutes" manual-section-trigger="true">
        Mod Note Mutes
      </h4>
      <p>
        To create interesting variations on the fly, it is posible to Mute
        individual Mod Notes of a pattern. To do so, hold [DOWN] and hit the
        mod note's [NOTE] key you want to mute/unmute. All the selected mod
        notes will be muted/unmuted upon releasing the [DOWN] key. The muted
        mod notes are indicated by a blinking [NOTE] key.
      </p>
      <p>
        To unmute all mod notes (and steps : see step mutes) at once, hold
        [DOWN] and press [DELETE].
      </p>
      <h4 id="sequencer-mod-note-copy" manual-section-trigger="true">
        Copy and paste operations
      </h4>
      <p>
        One can copy/paste a Mod Note - hold [FUNC] + [COPY], hit the mod note
        [NOTE] key you want to copy, then hold [FUNC] + [PASTE] and hit the
        destination [NOTE] key.
      </p>
      <p>
        You can also “import/export” mod note to the current patch. To copy the
        current patch to a mod note, hold [RECORD] and press the desired [NOTE]
        key. Inversely, hold a [NOTE] key and press [RECORD] to copy a mod note
        to the current patch.
      </p>
      <h2 id="randomizer" manual-section-trigger="true">
        Randomizer
      </h2>
      <p>
        Mono features several randomizing features to assist the musician's
        creative process. They allow users to explore the depth of Mono's
        synthesis engine. There are different randomize options : randomize
        page, step, parameter, accent, slide, and Mod Note.
      </p>
      <h3 id="randomizer-page" manual-section-trigger="true">
        Page randomizer
      </h3>
      <p>
        The page randomizer is useful to get a pattern going quickly, or to
        create alternative patterns starting from a base pattern. It adds
        between 1 and 4 note trigs with random pitch on said page. The pitch is
        always quantized to the scale of the pattern - this way, you can safely
        use it in live situations. Of course, you can undo/redo this operation.
        The page randomizer was designed to be used as an “additive tool” - you
        can start from scratch on an empty pattern or create alterations on a
        rhythmic pattern, and then undo to go back to the original pattern. The
        added step won't contain parameter offsets, probability, ratchet or
        microshift. They will however be slided or accented at random.
      </p>
      <p>
        To randomize a page, hold [FUNC] + [TEMPO], and hit the desired [PAGE]
        key.
      </p>
      <h3 id="randomizer-pitch" manual-section-trigger="true">
        Pitch/Mod Note randomizer
      </h3>
      <p>
        The pitch randomizer allows the user to randomize the pitch of all the
        active notes in the current pattern. It won't add or remove notes. As
        you might expect, the pitch of the randomized pitch will be quantized to
        the current scale.
      </p>
      <p>
        The pitch randomizer is contextual, when you are in player mode it won't
        affect the mod notes. When in mod note mode, it won't affect the patch
        notes, and will randomize the mod notes of the pattern, picking only mod
        notes from the current page.
      </p>
      <p>
        To randomize pitch, hold [FUNC] + [TEMPO], and hit the [PATTERN] key.
      </p>
      <h3 id="randomizer-dice" manual-section-trigger="true">
        Step Dice
      </h3>
      <p>
        Step dice will take all the trigs of a selected range and randomly
        reassign them to a new position. Just like the pitch randomizer it is
        contextual. It will dice only the patch notes in player mode and the mod
        notes in mod note mode. Hold your breath, this is the only 4-keys
        combination on Mono. To step dice, hold [FUNC] + [TEMPO], hold the [SEQ]
        key ending your range, and press the [SEQ] key starting your range in this order.
      </p>
      <h3 id="randomizer-step" manual-section-trigger="true">
        Step randomizer
      </h3>
      <p>
        The step randomizer as its name suggests randomizes a single step. It
        adds a random note trig to the desired step, the pitch is also quantized
        to the pattern. It will also randomize some synth parameter offsets. The
        parameter offsets being randomized are selected at random, and the value
        as well. To avoid going too wild, only the synth parameters are
        randomized, not the modulation parameters. The Freq and detune parameter
        are never randomized to keep the randomized step in tune.
      </p>
      <p>
        To randomize a step, hold [FUNC] + [TEMPO], and hit the desired [SEQ]
        key.
      </p>

      <h3 id="randomizer-parameter" manual-section-trigger="true">
        Parameter randomizer
      </h3>
      <p>
        The parameter randomizer basically creates a random automation on a
        modulation or synth parameter. There is a 50% chance that a parameter
        offset is added on each step. The random value is also restricted to a
        range set by the musician, the offsets will never exceed these values.
      </p>
      <p>
        To randomize a parameter, hold [FUNC] + [TEMPO], turn the desired
        parameter to the desired lower value, then turn it the other way, to the
        desired upper value. On releasing [FUNC], the parameter will be
        randomized.
      </p>
      <h4 id="randomizer-range" manual-section-trigger="true">
         Randomize a step range
      </h4>
       <p>
         To randomize a range of step, hold [TEMPO] + [FUNC], 
         hold the [SEQ] starting the range, and then press the 
         [SEQ] ending the range, release, and voila ! 
         It will randomize all parameters of mixer, filter and envelope section.
       </p>
       <h4 id="range-autom-randomizer" manual-section-trigger="true">
         Randomize automation range
      </h4>
       <p>
         Randomize automation range : hold [TEMPO] + [FUNC], set the desired range by 
         holding the first [SEQ] and pressing the end [SEQ]. Release the [SEQ] switches 
         (not [TEMPO] and [FUNC]) then turn the desired knobs parameter left and right to set the 
         randomisation range, just like the randomize automation feature.
       </p>
      <h3 id="randomizer-accent" manual-section-trigger="true">
        Accent and slide randomizer
      </h3>
      <p>
        To randomize accent or slide on a pattern, hold [FUNC] + [TEMPO], and
        hit [ACCENT] or [SLIDE]. This will clear the current accent/slide and
        place accent/slide on note trigs at random.
      </p>
      <h3 id="randomizer-mod" manual-section-trigger="true">
        Mod note randomizer
      </h3>
      <p>
        The Mod note randomizer is the wildest of all. It allows musicians to
        randomize a Mod Note in the Mod Note mode. Since it is not limited to
        the 48 parameter offsets per step, it randomizes every single synth and
        modulation parameters. The result will usually be extremely weird
        bleeping noises, but we all love that don't we ?
      </p>
      <p>
        To randomize a Mod note you need to enable the Mod Note mode with [UP] +
        [DOWN]. Hold [FUNC] + [TEMPO], then hit one of the 8 bottom [NOTE] keys
        to randomize the desired mod note.
      </p>
      <h2 id="settings" manual-section-trigger="true">
        Project settings
      </h2>
      <p>
        First things first, let's be honest - editing settings on Mono is not
        the best user experience. There is no way to make the process easy
        without a display, so you either need a good memory, or you need to keep
        the manual close. The process is always the same though, hold [FUNC],
        hit the desired settings, use the [SEQ] and [PAGE] key to select the
        desired value. Exit by hitting [FUNC] again.
      </p>
      <h3 id="settings-midi" manual-section-trigger="true">
        MIDI/Clock
      </h3>
      <p>
        This setting allows user to set the Mono MIDI channel and clock source.
        Use the [SEQ] button to select the midi channel from 1 to 16, and use
        the page button to set the clock source. there are 4 clock source :
      </p>
      <ul>
        <li>
          Internal [PAGE A] (default) : Mono uses its internal clock, and [RUN]
          key to manage playback.
        </li>
        <li>
          MIDI [PAGE B] : Mono uses the clock received on the MIDI port,
          playback operation is handled with MIDI start stop messages. The [RUN]
          key can still be used to handle transport.
        </li>
        <li>
          USB [PAGE C] : Mono uses the clock received on the USB port, playback
          operation is handled with MIDI start stop messages. The [RUN] key can
          still be used to handle transport.
        </li>
        <li>
          CV [PAGE D] : Mono uses its CV clock input as clock. In this mode,
          each step is triggered by an incoming pulse signal at the CV clock
          input, and the pattern restarts everytime a pulse is received at the
          reset input. Note that when using CV clock, some features of Mono
          can't work : microshift, ratchet, and swing. This mode really shines
          when using a weird semi-random clock source like a Make Noise
          Wogglebug.
        </li>
      </ul>
      <p>
        You can use the [NOTE] key to enable/disable the mod note MIDI channel.
        It allows to use the channel directly after your main channel to trigger mod note via MIDI.
        (If you use channel 1, then channel 2 will trigger mod notes when enabled).
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          C
        </span>{" "}
        Disable ModNoteMidiChannel
        <span className="param-enum" style={{ marginLeft: "20px" }}>
          C#
        </span>{" "}
        Enable ModNoteMidiChannel
        </p>
      <h3 id="settings-pot" manual-section-trigger="true">
        Pot mode
      </h3>
      <p>
        The [POT MODE] setting changes the behaviour of the potentiometers when
        the physical potentiometers doesn't reflect the internal stored value.
        This happens on synth parameters when switching patterns, and on
        modulation parameters when selecting another synth parameters or editing
        ratchet, probability or microshift. There are three modes :
      </p>
      <ul>
        <li>
          Jump [SEQ 1] (default) : Uses absolute value based upon the position
          of the pot when edited. Turn a pot and the parameter value jumps
          immediately from the stored value to the edited value.
        </li>
        <li>
          Passthru [SEQ 2] :Turning the pot has no effect until after the edited
          value equals the stored value (that is, until the edited value “pass
          through” the stored value).
        </li>
        <li>
          Relative [SEQ 3] : Changes are relative to the stored setting. In
          relative mode, the full value range is not available until either the
          minimum or the maximum value and the respective lower or upper limit
          of the pot's travel is reached. For example, let's say the cut-off
          parameter has an internal value range of 0 to 100 (chill out geeks, it
          is 16 bit internally). The physical position of the pot is at 80 and
          you load a program with a stored value of 20. Turning the pot all the
          way up will only set the parameter to 40. To get the maximum value you
          first have to turn down until the value is at the other bound of the
          range, in this case 0, or fully counterclockwise.
        </li>
      </ul>
      <h3 id="settings-bend" manual-section-trigger="true">
        Bend Rg
      </h3>
      <p>
        The [BEND RG] sets the range of the pitch wheel bend in semitones. Use
        the [SEQ] keys to select the range from 1 to 16, 3 being the default
        value.
      </p>

      <h3 id="settings-cv2" manual-section-trigger="true">
        CV2 Src
      </h3>
      <p>
        [CV2 SRC] settings allow to change the source of the CV2 output, 4
        sources are available :
      </p>
      <ul>
        <li>
          Osc1 [SEQ 1] (default) : The CV2 out outputs the current value of Osc1
          frequency in V/Oct, between -5/+5V.
        </li>
        <li>
          Osc2 [SEQ 2] : The CV2 out outputs the current value of Osc2 frequency
          in V/Oct, between -5/+5V.
        </li>
        <li>
          Cut-off [SEQ 3] : The CV2 out outputs the current value of the cut-off
          frequency in V/Oct, between -5/+5V.
        </li>
        <li>
          Envelope [SEQ 4] : The CV2 out outputs the main envelope between
          0/+8V.
        </li>
        <li>
          Output level [SEQ 5] :The CV2 out outputs the current value of the
          "volume" parameter, with its modulation and envelope.
        </li>
        <li>
          CV Clock [SEQ 6] to [SEQ 9]:The CV2 out outputs a quarter note CV
          Clock from the internal clock of Mono. In this setting, a reset signal
          replaces the accent at the [ACCENT] output. [SEQ 6] sends a whole note
          trig, [SEQ 7] a quarter note trig, [SEQ 8] a heighth note trig, and
          [SEQ 9] a sixteenth note trig.
        </li>
      </ul>
      <h3 id="settings-trigger" manual-section-trigger="true">
        Clock/Trigger In
      </h3>
      <p>
        On the [CV2 SRC] settings the page keys A and B have a different purpose
        (yes, we were out of switches ...) :
      </p>
      <ul>
        <li>
          Clock Input [PAGE A] (default) : The CV clock input serves as a ...
          clock input.
        </li>
        <li>
          Trigger-in [PAGE B] : The CV Clock input is reconfigured as a trigger
          in input.
        </li>
      </ul>
      <h2 id="update" manual-section-trigger="true">
        Update and calibration
      </h2>
      <h3 id="update-firmware" manual-section-trigger="true">
        Updating firmware
      </h3>
      <p>
        The firmware file is a standard .syx file. To update, connect Mono to a
        computer using the USB cable (MIDI won't work). Hold [PATTERN] + [RUN]
        and power the unit. The [SEQ] LEDs will flash. Launch your favorite
        sysex program (“Sysex Librarian” on OS X, “MIDI SysEx Transfer Utility”
        on windows and “amidi” on linux have all been tested). Set the output to
        Mono, and “Delay between messages” at 1ms. Open the monosynth_VX.X.syx
        file, and press send. The transfer takes about a minute or two. [SEQ]
        LEDs will show the progress. Once the update complete, the synth will
        boot as usual.
      </p>
      <h3 id="update-oscillators" manual-section-trigger="true">
        Oscillators calibration
      </h3>
      <p>
        Like every analog synthesizer, the oscillators needs to be calibrated
        from time to time. Mono's oscillator and filter are no exception. To
        calibrate the oscillator and filter, turn off the unit, hold [C] + [D]
        on the mini-keyboard, and turn the unit back on. The calibration
        procedure will start. The [SEQ] LEDs indicate the progress of
        calibration of each oscillator and filter, so it will restart at the
        beginning twice. The calibration procedure takes about 3 minutes. It is
        recommanded to calibrate Mono when it is hot, after being powered for at
        least 15 minutes. Note that the VCA is open when calibrating, so either
        disconnect the output or mute the synth's channel !
        <strong>Restart the synth once calibration is done.</strong>
      </p>
      <h3 id="update-resonance" manual-section-trigger="true">
        Resonance calibration
      </h3>
      <p>
        The maximum amount of resonance you want to get out of your synth is
        very subjective. Some people like very distorted self-oscillating
        resonance, others prefer no self-oscillation. On Mono it is possible to
        calibrate the maximum resonance level. To do so, turn off the synth,
        hold [C#] + [D#], and turn it back on. [PATTERN] and [RUN] LED will
        flash. You can play the synth normally and set the resonance at desired
        maximum level (best way is to turn down both osc levels, hold a note and
        increase resonance until you are happy with the self-oscillation level).
        When you're done, press [RUN], the resonance maximum will be saved.
      </p>
      <h3 id="update-CV" manual-section-trigger="true">
        CV calibration
      </h3>
      <p>
          To calibrate the CV output, turn off the unit, hold [UP] + [DOWN] on the mini-keyboard, and turn the unit back on. You should see the [SEQ1] and [FREQ OSC1] led blinking.
          With a multimeter, measure the voltage at the CV1 output. With [FREQ OSC1] and [FINE OSC1], set the voltage to -5V. When done, press [C]. Repeat the procedure until [SEQ11] (+5V).
          When done with OSC1, do the same for OSC2 (don't forget to plug your cable in CV2 !).
          You're done !
      </p>
      <h2 id="midi" manual-section-trigger="true">
        Midi implementation
      </h2>
      <h3 id="midi-velocity" manual-section-trigger="true">
        Velocity
      </h3>
      <p>
        The velocity value of an incoming MIDI note affects the amplification
        level of that note, internal default value is 100, any incoming value
        below 100 will result in a quieter note. The values above 100 will apply
        an accent with a ratio between 0 and 100%.
      </p>
      <h3 id="midi-cc" manual-section-trigger="true">
        Parameter editing via CC
      </h3>
      <p>
        Mono synth and modulation parameters can be edited via control change
        message, it is also possible to select the active parameter via CC.
        Potentially, the synth engine can be entirely controlled via MIDI. It is
        also possible to send the parameter automation with the [PARAM SND]
        setting, on the same CC. This is disabled by default.
      </p>
      <h4 id="midi-cc-table" manual-section-trigger="true">
        CC parameter table
      </h4>
      <p>
        <Row className="row-settings">
          <Col className="settings-col">
            <span className="param-enum">7</span> Output Volume
            <br />
            <span className="param-enum">14</span> Reset Modulator Phase
            <br />
            <span className="param-enum">15</span> Go To Step
            <br />
            <span className="param-enum">43</span> Attack
            <br />
            <span className="param-enum">44</span> Decay
            <br />
            <span className="param-enum">45</span> Sustain
            <br />
            <span className="param-enum">46</span> Release
            <br />
            <span className="param-enum">47</span> Filter Envelope Amount
            <br />
            <span className="param-enum">48</span> Oscillator 1 Freq
            <br />
            <span className="param-enum">49</span> Oscillator 1 Detune
            <br />
            <span className="param-enum">50</span> Oscillator 1 Wave
            <br />
            <span className="param-enum">51</span> Oscillator 1 Volume
            <br />
            <span className="param-enum">52</span> FM Amount
            <br />
            <span className="param-enum">53</span> Sync On/Off
            <br />
            <span className="param-enum">54</span> Oscillator 2 Freq
            <br />
          </Col>
          <Col className="settings-col">
            <span className="param-enum">55</span> Oscillator 2 Detune
            <br />
            <span className="param-enum">56</span> Oscillator 2 Wave
            <br />
            <span className="param-enum">57</span> Oscillator 2 Volume
            <br />
            <span className="param-enum">74</span> Filter Cut-Off
            <br />
            <span className="param-enum">75</span> Filter Resonance
            <br />
            <span className="param-enum">76</span> Filter Color
            <br />
            <span className="param-enum">77</span> Filter Follow On/Off
            <br />
            <span className="param-enum">78</span> Active X-Mod Rate
            <br />
            <span className="param-enum">79</span> Active X-Mod Amount
            <br />
            <span className="param-enum">80</span> Active X-Env Attack
            <br />
            <span className="param-enum">81</span> Active X-Env Decay
            <br />
            <span className="param-enum">82</span> Active X-Env Amount
            <br />
            <span className="param-enum">83</span> Active X-Mod Type (Cycle)
            <br />
            <span className="param-enum">84</span> Active X-Mod Wave (Cycle)
            <br />
          </Col>
        </Row>
      </p>
      <h3 id="midi-pc" manual-section-trigger="true">
        Program change
      </h3>
      <p>
        Mono supports program change to switch pattern, send a program change
        between 0 and 63 to set the current pattern. Note that play mode will
        affect the behavior just as it would if you switch pattern manually.
      </p>

      <h3 id="midi-dump" manual-section-trigger="true">
        Program dump/receive
      </h3>
      <p>
        Program dump allows users to dump a project as a MIDI sysex file to a
        computer. It is useful if you need room for new projects, or simply as a
        backup. To dump a program, launch your Sysex software, set it in
        reception mode with Mono as source, hold [FUNC] and press [PGM DUMP]
      </p>
      <p>
        To load a project back to Mono, open the projects in which you want to
        receive the sysex file, hold [FUNC] and press [PGM RCV]. On your sysex
        software, send the project to Mono. As soon as you save the received
        project, it will overwrite the old one permanently. Don't forget to save 
        the Project before leaving and load another project.

      </p>
    </>
  )
};

export default monoManualV2Data;
